<style scope>
p {
  font-size: 12px;
}
</style>
<template>
  <div style="margin-left: 50px; margin-top: 25px">
    <p style="margin-left: -9px" class="mx-auto">
      <span style="font-family: Arial, Helvetica, sans-serif">
        <img
          src="data:image/png;base64,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"
          style="width: 132.6pt; height: 34.2pt"
          alt="image"
        />
      </span>
    </p>

    <p>
      <span style="font-family: Arial, Helvetica, sans-serif"
        ><span style="font-size: 10pt"
          ><span style="font-size: 12pt"
            ><span style="color: black">Corporate HRD Department</span></span
          ></span
        ></span
      >
    </p>

    <p style="margin-left: 29px">
      <span style="font-family: Arial, Helvetica, sans-serif"
        ><span style="font-size: 10pt"
          ><strong
            ><span style="font-size: 12pt"
              ><span style="color: black"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                FORMULIR PERMINTAAN CUTI
              </span></span
            ></strong
          ></span
        ></span
      >
    </p>

    <p style="margin-left: 29px">&nbsp;</p>

    <p>
      <span style="font-family: Arial, Helvetica, sans-serif"
        ><span style="font-size: 10pt"
          >Perusahaan
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <input
            type="checkbox"
            id="vta"
            value="vta"
            style="margin-bottom: -6px; color: red"
            v-model="checkedPerusahaan"
            disabled
          />&nbsp;<span style="font-size: 10pt"
            >VTA&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <input
            type="checkbox"
            id="tmk"
            value="tmk"
            style="margin-bottom: -6px"
            v-model="checkedPerusahaan"
            disabled
          />&nbsp;<span style="font-size: 10pt"
            >TMK&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <input
            type="checkbox"
            id="sii"
            value="sii"
            style="margin-bottom: -6px"
            v-model="checkedPerusahaan"
            disabled
          />&nbsp;<span style="font-size: 10pt"
            >SII&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <input
            type="checkbox"
            id="ags"
            value="ags"
            style="margin-bottom: -6px"
            v-model="checkedPerusahaan"
            disabled
          />&nbsp;<span style="font-size: 10pt"
            >&nbsp;AGS
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <input
            type="checkbox"
            id="bmt"
            value="bmt"
            style="margin-bottom: -6px"
            v-model="checkedPerusahaan"
            disabled
          />&nbsp;<span style="font-size: 10pt"> BMT</span></span
        ></span
      >
    </p>

    <p>
      <span
        style="font-family: Arial, Helvetica, sans-serif; margin-left: 39px"
      >
        <span style="font-size: 10pt"
          >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp;
          <input
            type="checkbox"
            id="edl"
            value="edl"
            style="margin-bottom: -6px"
            v-model="checkedPerusahaan"
            disabled
          />&nbsp;<span style="font-size: 10pt"
            >EDL&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span
          >
          <input
            type="checkbox"
            id="eka"
            value="eka"
            style="margin-bottom: -6px"
            v-model="checkedPerusahaan"
            disabled
          />&nbsp;<span style="font-size: 10pt"
            >EKA&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <input
            type="checkbox"
            id="udk"
            value="udk"
            style="margin-bottom: -6px"
            v-model="checkedPerusahaan"
            disabled
          />&nbsp;<span style="font-size: 10pt"
            >UDK&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <input
            type="checkbox"
            id="msi"
            value="msi"
            style="margin-bottom: -6px"
            v-model="checkedPerusahaan"
            disabled
          />&nbsp;<span style="font-size: 10pt">MSI</span></span
        ></span
      >
    </p>
    <table style="border: none; margin-left: -3.6pt; border-collapse: collapse">
      <tbody>
        <tr>
          <td style="width: 124pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Mulai tanggal</span
              >
            </p>
          </td>
          <td
            style="
              width: 124pt;
              border-top: none;
              border-right: none;
              border-left: none;
              border-image: initial;
              border-bottom: 1pt solid black;
              padding: 0cm 5.4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span
                style="
                  font-size: 12px;
                  line-height: 20px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp; {{ formatDate(tanggalMulai) }}
              </span>
            </p>
          </td>
          <td style="width: 100pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >&nbsp;&nbsp;&nbsp;Sampai tanggal</span
              >
            </p>
          </td>
          <td
            style="
              width: 120.15pt;
              border-top: none;
              border-right: none;
              border-left: none;
              border-image: initial;
              border-bottom: 1pt solid black;
              padding: 0cm 5.4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span
                style="
                  font-size: 12px;
                  line-height: 20px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp; {{ formatDate(tanggalBerakhir) }}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 144pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Kembali bekerja pada</span
              >
            </p>
          </td>
          <td
            colspan="3"
            style="
              width: 383.15pt;
              border-top: none;
              border-right: none;
              border-left: none;
              border-image: initial;
              border-bottom: 1pt solid black;
              padding: 0cm 5.4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span
                style="
                  font-size: 12px;
                  line-height: 20px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp; {{ formatDate(kembaliTanggal) }}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td
            style="
              width: 144pt;
              padding: 0cm 5.4pt;
              height: 3.4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Alasan mengambil cuti</span
              >
            </p>
          </td>
          <td
            colspan="3"
            style="
              width: 383.15pt;
              border-top: none;
              border-right: none;
              border-left: none;
              border-image: initial;
              border-bottom: 1pt solid black;
              padding: 0cm 5.4pt;
              height: 3.4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span
                style="
                  font-size: 12px;
                  line-height: 20px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp; {{ keterangan }}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 144pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span
                style="
                  font-size: 12px;
                  line-height: 20px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
          </td>
          <td
            colspan="3"
            style="
              width: 383.15pt;
              border-top: none;
              border-right: none;
              border-left: none;
              border-image: initial;
              border-bottom: 1pt solid black;
              padding: 0cm 5.4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span
                style="
                  font-size: 12px;
                  line-height: 20px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 144pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Selama cuti saya dapat</span
              >
            </p>
          </td>
          <td
            colspan="3"
            style="
              width: 383.15pt;
              border-top: none;
              border-right: none;
              border-left: none;
              border-image: initial;
              border-bottom: 1pt solid black;
              padding: 0cm 5.4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span
                style="
                  font-size: 12px;
                  line-height: 20px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp; {{ no_tlp }}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td
            style="
              width: 144pt;
              padding: 0cm 5.4pt;
              height: 4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Dihubungi di</span
              >
            </p>
          </td>
          <td
            colspan="3"
            style="
              width: 383.15pt;
              border-top: none;
              border-right: none;
              border-left: none;
              border-image: initial;
              border-bottom: 1pt solid black;
              padding: 0cm 5.4pt;
              height: 4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span
                style="
                  font-size: 12px;
                  line-height: 20px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 144pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span
                style="
                  font-size: 12px;
                  line-height: 20px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
          </td>
          <td
            colspan="3"
            style="
              width: 383.15pt;
              border-top: none;
              border-right: none;
              border-left: none;
              border-image: initial;
              border-bottom: 1pt solid black;
              padding: 0cm 5.4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span
                style="
                  font-size: 12px;
                  line-height: 20px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <p
      style="
        margin-top: 0cm;
        margin-right: 0cm;
        margin-bottom: 0.0001pt;
        margin-left: 0cm;
        line-height: normal;
        font-size: 12px;
        font-family: 'Calibri', sans-serif;
      "
    >
      <span style="font-family: 'Times New Roman', serif">&nbsp;</span>
    </p>
    <p
      style="
        margin-top: 0cm;
        margin-right: 0cm;
        margin-bottom: 0.0001pt;
        margin-left: 0cm;
        line-height: normal;
        font-size: 12px;
        font-family: 'Calibri', sans-serif;
        text-align: justify;
      "
    >
      <span style="font-family: 'Arial', sans-serif; color: black"
        >Apabila dalam 5 ( lima ) hari sejak berakhirnya cuti, saya tidak
        kembali tanpa pemberitahuan <br />
        terlebih dahulu, maka saya dianggap telah mengundurkan diri.</span
      >
    </p>
    <p
      style="
        margin-top: 0cm;
        margin-right: 0cm;
        margin-bottom: 0.0001pt;
        margin-left: 0cm;
        line-height: normal;
        font-size: 12px;
        font-family: 'Calibri', sans-serif;
        text-align: justify;
      "
    >
      <span style="font-family: 'Arial', sans-serif; color: black">&nbsp;</span>
    </p>
    <table style="border: none; margin-left: -3.3pt; border-collapse: collapse">
      <tbody>
        <tr>
          <td
            colspan="2"
            style="width: 121pt; padding: 0cm 5.4pt; vertical-align: top"
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 3cm;
                margin-bottom: 0.0001pt;
                margin-left: 3.2cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: center;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Disetujui oleh,</span
              >
            </p>
          </td>
          <td
            colspan="2"
            style="width: 266.15pt; padding: 0cm 5.4pt; vertical-align: top"
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 4.2cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: center;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Dibuat oleh,</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 81pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 12px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
          </td>
          <td style="width: 160pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <strong
                ><span
                  style="
                    font-size: 12px;
                    line-height: 20px;
                    font-family: 'Arial', sans-serif;
                    color: black;
                  "
                  >&nbsp;</span
                ></strong
              >
            </p>
            <img
              src="data:image/png;base64,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"
              style="
                width: 122.6pt;
                height: 35.2pt;
                margin-left: -0.7cm;
                margin-top: 15px;
              "
              alt="image"
            />
          </td>
          <td style="width: 90pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 12px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 12px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 12px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 12px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 12px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
          </td>
          <td style="width: 160.15pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 12px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 50pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Nama &nbsp; :</span
              >
            </p>
          </td>
          <td
            style="
              width: 50pt;
              border-top: none;
              border-right: none;
              border-left: none;
              border-image: initial;
              border-bottom: 1pt solid black;
              padding: 0cm 5.4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <strong
                ><span
                  style="
                    font-size: 12px;
                    line-height: 20px;
                    font-family: 'Arial', sans-serif;
                    color: black;
                  "
                  >&nbsp; Handi Surahman</span
                ></strong
              >
            </p>
          </td>
          <td style="width: 50pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Nama &nbsp; :</span
              >
            </p>
          </td>
          <td
            style="
              width: 50pt;
              border-top: none;
              border-right: none;
              border-left: none;
              border-image: initial;
              border-bottom: 1pt solid black;
              padding: 0cm 5.4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <strong
                ><span
                  style="
                    font-size: 12px;
                    line-height: 20px;
                    font-family: 'Arial', sans-serif;
                    color: black;
                  "
                  >&nbsp; {{ nama }}
                </span></strong
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 50pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Tanggal,</span
              >
            </p>
          </td>
          <td
            style="
              width: 50pt;
              border-top: none;
              border-right: none;
              border-left: none;
              border-image: initial;
              border-bottom: 1pt solid black;
              padding: 0cm 5.4pt;
              vertical-align: bottom;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span
                style="
                  font-size: 12px;
                  line-height: 20px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp; {{ formatDate(tanggalSaatIni) }}</span
              >
            </p>
          </td>
          <td style="width: 50pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Tanggal,</span
              >
            </p>
          </td>
          <td
            style="
              width: 50pt;
              border-top: none;
              border-right: none;
              border-left: none;
              border-image: initial;
              border-bottom: 1pt solid black;
              padding: 0cm 5.4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: 20px;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
              "
            >
              <span
                style="
                  font-size: 12px;
                  line-height: 20px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp; {{ formatDate(tanggalSaatIni) }}</span
              >
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      style="
        margin-top: 0cm;
        margin-right: 1.3cm;
        margin-bottom: 8pt;
        margin-left: 0cm;
        line-height: 107%;
        font-size: 12px;
        font-family: 'Calibri', sans-serif;
        border: none;
        border-bottom: double black 1pt;
        padding: 0cm 0cm 2pt 0cm;
      "
    >
      <p
        style="
          margin-top: 0cm;
          margin-right: 0cm;
          margin-bottom: 0.0001pt;
          margin-left: 0cm;
          line-height: normal;
          font-size: 12px;
          font-family: 'Calibri', sans-serif;
          text-align: justify;
          border: none;
          padding: 0cm;
        "
      >
        <span style="font-family: 'Times New Roman', serif">&nbsp;</span>
      </p>
    </div>
    <p
      style="
        margin-top: 0cm;
        margin-right: 0cm;
        margin-bottom: 0.0001pt;
        margin-left: 0cm;
        line-height: normal;
        font-size: 12px;
        font-family: 'Calibri', sans-serif;
        text-align: justify;
      "
    >
      <span style="font-family: 'Arial', sans-serif; color: black"
        >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span
      >
    </p>
    <p
      style="
        margin-top: 0cm;
        margin-right: 0cm;
        margin-bottom: 0.0001pt;
        margin-left: -711px;
        line-height: normal;
        font-size: 12px;
        font-family: 'Calibri', sans-serif;
        text-align: center;
        text-indent: -21.6pt;
      "
    >
      <strong
        ><span
          style="
            font-family: 'Arial', sans-serif;
            color: black;
            margin-left: 150px;
          "
          >DIISI OLEH PERSONALIA</span
        ></strong
      >
    </p>
    <p
      style="
        margin-top: 0cm;
        margin-right: 0cm;
        margin-bottom: 0.0001pt;
        margin-left: 0cm;
        line-height: normal;
        font-size: 12px;
        font-family: 'Calibri', sans-serif;
        text-align: justify;
      "
    >
      <span style="font-family: 'Arial', sans-serif; color: black">&nbsp;</span>
    </p>
    <table style="border: none; border-collapse: collapse">
      <tbody>
        <tr>
          <td style="width: 261.75pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Sisa hak cuti tahun &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span
              >
            </p>
          </td>
          <td style="width: 261.8pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: right;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
                &nbsp; &nbsp; &nbsp; {{ sisaCuti }} Hari kerja</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 261.75pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Hak cuti tahun ini &nbsp; &nbsp; {{ hakCuti }}
              </span>
            </p>
          </td>
          <td style="width: 261.8pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="margin-top:font-weight:bold;0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:12px;font-family:'Calibri',sans-serif;text-align:right;"
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                &nbsp;&nbsp;12 Hari kerja</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 261.75pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Hak cuti lainnya</span
              >
            </p>
          </td>
          <td
            style="
              width: 261.8pt;
              border-top: none;
              border-right: none;
              border-left: none;
              border-image: initial;
              border-bottom: 1pt solid black;
              padding: 0cm 5.4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: right;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;Hari
                kerja</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 261.75pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Jumlah hak cuti</span
              >
            </p>
          </td>
          <td style="width: 261.8pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: right;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; Hari kerja</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 261.75pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 12px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
          </td>
          <td style="width: 261.8pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 12px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            style="
              width: 261.75pt;
              padding: 0cm 5.4pt;
              height: 4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Permintaan</span
              >
            </p>
          </td>
          <td
            style="
              width: 261.8pt;
              padding: 0cm 5.4pt;
              height: 4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 12px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 261.75pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Dari tanggal
                <strong
                  ><em
                    >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</em
                  ></strong
                >
                &nbsp;</span
              >
            </p>
          </td>
          <td style="width: 261.8pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: right;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; Hari kerja</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 261.75pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Pemotongan cuti lainnya</span
              >
            </p>
          </td>
          <td
            style="
              width: 261.8pt;
              border-top: none;
              border-right: none;
              border-left: none;
              border-image: initial;
              border-bottom: 1pt solid black;
              padding: 0cm 5.4pt;
              vertical-align: top;
            "
          >
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: right;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;Hari
                kerja</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 261.75pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Jumlah pemotongan cuti</span
              >
            </p>
          </td>
          <td style="width: 261.8pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: right;
              "
            >
              <strong
                ><span style="font-family: 'Arial', sans-serif; color: black"
                  >&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;</span
                ></strong
              ><span style="font-family: 'Arial', sans-serif; color: black"
                >Hari kerja</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 261.75pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 12px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
          </td>
          <td style="width: 261.8pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span
                style="
                  font-size: 12px;
                  font-family: 'Arial', sans-serif;
                  color: black;
                "
                >&nbsp;</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 261.75pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: justify;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >Sisa cuti</span
              >
            </p>
          </td>
          <td style="width: 261.8pt; padding: 0cm 5.4pt; vertical-align: top">
            <p
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0.0001pt;
                margin-left: 0cm;
                line-height: normal;
                font-size: 12px;
                font-family: 'Calibri', sans-serif;
                text-align: right;
                z-index: 9999;
              "
            >
              <span style="font-family: 'Arial', sans-serif; color: black"
                >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;Hari
                kerja</span
              >
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <p
      style="
        margin-top: 0cm;
        margin-right: 0cm;
        margin-bottom: 8pt;
        margin-left: 0cm;
        line-height: 107%;
        font-size: 12px;
        font-family: 'Calibri', sans-serif;
      "
    >
      &nbsp;
    </p>
    <br />
    <br />
    <br />
    <img
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAScAAAE7CAYAAACfTkehAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAHIBSURBVHhe7b2JcyzJdd57ekdjB+6dITkUd4qyFi+SN9kOh144wv673h9lRzyHZIthybYka6E2kqJFitsMZ+ZeAA2g0Xt1v+93sk6j0IM7cxcAtwHkB2RXVVZmVubJk1+dzMrKqi0Ey8jIyFgz1MttRkZGxlohk1NGRsZaIpNTRkbGWiKTU0ZGxloik1NGRsZaIpNTRkbGWiKTU0ZGxloik1NGRsZaIpNTRkbGWiKTU0ZGxloik1NGRsZaIpNTRkbGWiKTU0ZGxloik1NGRsZaIpNTRkbGWiKTU0ZGxloik1NGRsZaIpNTRkbGWiKTU0ZGxloik1NGRsZaIpNTRkbGWiKTU0ZGxloik1NGRsZaIpNTRkbGWiKTU0ZGxloik1NGRsZaIpNTRkbGDWBRcTeD2kIo9zMyMjJejCpT1Mqt+8WJclvjZAR4fWTLKSMj4/VRg5DC3SwyOWVkZHwmnH5kDM3l2CYq0u+y48V2nnZvCJmcMjIyXgpQj5MUB5DS0s21kZsT4uYIKo85ZWRkfCYgiSLtyqJZWG0ux0FRWDGbajP1MO1u12qNpod6U2TLKSMj46VQg5RwsmdwVsxtPpnapH9hw9MzG2vr1pObO29u82RyysjIeClgKdWdmLQjy2kxndn0vG+j3qlNzi+sLrLCoroJYgKZnDIyMl4CpbXkFlNhi9HYpsc9G/fOtD+xpqgrkclytPyNkckpI+ORAy6Z69c5hZ8VF7seqpjadEg37ljW0pnVxiNryGJqEKAmOmGOU57nlJGRcROAlhIBlQQFLhlpub+YqRs3HNjo/NTGfVlMk6GIqRAxYVXVbCFywt0EMYFMThkZjxhLMhKcg8QrPmWgJqLC0Y3jydxsbsVgZOOzMxvLYlpMJiKluY9B4SL+TSKTU0bGIwY2Tl2sguMIYprJE1e4uSRi4qncxdDGx6c26/XNxjOri7DqYrKbsZGuRyanjIzHDEipnPLNgDeHkFLho1AipdnEprKWRs+e2eJiYM1iYe1F3QfAmTZwm9MkMzllZGQkOFHJItJOnRnf47GI6dzGJye2GI2sPi2sIXJi8NunE6zgpq2oTE4ZGY8dFVahe9eQRVQbTaw479vk9MyKwcDqM3Xl6OIpjA+cs1NnEByn/TKNSlJvjExOGRmPGUs2SeNHdSemqRVnfZv2zm0uYmrMC1lK6Z05XvydizV8W7qlEeWWV9q9CWRyysh4wPgsvuBcmuOkPcaQZDExuXJyfGZ2MbIWc5g4p37c3B3hzYogJn+qpy1BPMWbQyanjIwHijSknZyPW8MqFYffXD8eYj622fDcBsfPbHR6YrXJyKcK8C4dJFRAQvrjGBJKRJT2fXvdINQbIpNTRsYDBpThtBGMEh7LEwKzvi/6Put7Oji32mzqA+JMLIhgc5/1fZkMT/bSGNQlQaVR8kj0zZHJKSPjwSKNI/HrBCO3nFyJD6bThJd3L2xydmYzVhWYTBIxcY7wEY8DEsPfSamKCkHdIDI5ZWQ8UEAYdf06p8gxTpTGiqAmWUXTqRPS5OTUivOB1UVUTBWoi42WRhCRcW8BmZwyMh4olgQjx2auv6LGb5pcyYu7o+dHtrgYWnNSWEvM1VrE6gJCyWqezltAJqeMjEcApgLwgm6TxeBGI5+/NDo5MRuPrF4UPr/JDaRyRQGfuwTS4VshikxOGRkPFUEwjBGJfOrqss37I5+/NBU5QVJ1n8OEacRYlH7l0hSBtHWU1tNdW1CZnDIyHijgEp9GoD9WFZhfjGzGxMrTvtWHY1+HyVcUEOvE/CV35T7xccFRd41MThkZ9xJBHSUqh7HLHCaspkUxs2I4tMlJz2Zn51YbjqzpC8SJtNwkUjAIqeK8WxeODcFI9A6RySkj494BlkhP3NzG8VdLkq3jfKS/GaSE33xi82HfBifPbHx+LAtqLL5JcZb8UxJPlY+ciMK9JWRyysi4p0izl0RCYhOoKJFVIUJKVhEv68765zY6OfZJlgyKE8bDEkeO7xGQCoQU6zrF4Hg4QBjcXSKTU0bGfYQzRdCTnFjEveiqsXLleJoGvntnNh8M0wu9nCdc6ZZdOPzXEJmcMjLuG4JNYJgKQfkvUwXGEytY6gRi6g99MLyhsIT2UBViivGldSSoTE4ZGfcSYpQlRC102eaFzScTm533bXLc85UrGywQhyWFRUUwhabzh3NSqiazZsjklJFxDwHJMPjtL+D6et46kMU0Y0ndkyP/MkptPkukJCbCXTGPICUd+/gSLvmuFTI5ZWTcM/jqk+WWnVqxsAWTK49P03ty45HOzdVlS8PkgaqlBCGx3G5DpAVBrSMyOWVk3CMEj7Dl4wKL6dxf2p0en9n87MIHwiEbPlDgazCVZLTafeMQglo+mYuE1wiZnDIy1g5OPcnRXXO39PHJALYoREzqxg36Nj7t2eyi78udMF2ARg3ZLPmoQkzhf+X8miKTU0bGWoGOWDlkDSkFJZUk5dYST+RERIv+uY17xza+OLNiNi7jJeLh6Vx6Qpe6gO6P00F049j4Ezv215CpMjllZKwNoItFadHQJUvdMucSWIVzDH5PZ1b0+z65cnTW0ynZUoQlpMLXajURUCKmAHskcemj1EjbT6TjdUMmp4yMdUGwhZwoCCryLpzP6eZ1k6Kw2mjsHyAYn5zabDiyRq2RunEpBcUtt2tKOK+CTE4ZGesIum9s/LecwwQxnfSsOD030z7TB7yLpu0nrKJye5+RySkjY11QsksQC4fem5PFNGeBuPMzm8rx9d2aL3eSzvs8ptj3mAlExd1XZHLKyFgjJDJJFOPjSzNZTcOxzc76Numd2mIyVqD0kUvIaElQOI/1cJDJKSNjjbAcpFbT9MmVLBB3LIvp5NRMxLRgCkFpKkFMNGDcC4npHjNWJqeMjDuFGCU24Sq7OF8kTt02/zLK8anNzy+sMZ35GNOiXrNCrZZwn2YteVr3mJhAJqeMjDsBQ9v+3M33lw7CwemPs4wvsbb37PTExifHNhv2bTGbKlwaY+J1ExzE5FbW1dQu3T0nJpDJKSPjTgF1lOyiff/DUuJf1tJ8PLLi/DQR06Dvn3BasICcQBQnKDFPTK58kXsIyOSUkXFHwJgJgwYC4cVcGMf9RUy+DhPLnfTObHpxIWNpVoYsURMlpSju7ZtIdNU9AGRyysi4CwSTyLEmJV040ZF71+ayjMZjm7GqgNxM3bpGvS5ygoEIUUavugdCQJ+GTE53BB9XKBWtihf5ZzxEpG5cuSsniiqmVoiMxsfHVvBlFD4JrnO8P9eoxcfEhXJT8lvCAyeoTE53jCCjVVLKBPXQAZMkZkmrUsrNZlYMhjbu9Wyq7pxNmfWdPnJZ83CX/ONcVnGPAZmc7gCrxLNKTBmPAPASP7AN4+HTma/v7R8hkMU0FzEtFjMFSh8ieFHDXBJUsNYDRianO0SQUlEUNp1OlwSFnvEmecbDRSKUVN+LWeELxM1OztN7cpOJPAsfIPdBculF1WoKRJfOXen3kJHJ6Q4QxAMZzedzGw0GdnF+bjPW5CkJi7fO9XupdOw8Bg18MCgrK+qtUnfpkDqW0VTMbdq/8FUFivMLa04La4lt6tKRRE4KzFM5NpU0gB/6ibR56MjkdBuQFiWFLB1aKYewfZ7KZGr10zObf/yxWV93zmIiS39uMxFUoRj+kIZHOfE4J2PNAfVEhV1WnN+McDrik0210dDs6NiKo+e2GA0UZCYrqJyYCUEt6tKRRDuQFBZSFRy6RfVIdCKT0x0C5UrLXEhR1a3jEz6j42N/TUH9PD/nt1eU9RrlzFhHpPpKUyJFQ2W9OeHgr/pkHab5kFnfZzbtndgckipETG4tp/BUdbzEm5GQyeltQAqIYs5nU5vw/lTvzMcgalhU3GFRbWmpKzlam3EPQEUxf8mrlxpMe6rP+UDEdMbA95nPYfJldpeh2GZch0xObwFpAh5qKYWeFbKcBv7ZaMYgsKjo03kYCKqMk7GmcI5Jd5FL+ymRDiTEAnHJYlL9iqTo6kFj3tXP+FRkcnorSIo8FwkxytCYiYhkOY2Perq7xouePFYu0OIyTsZ6YtW0TRRV4+nbeGSTkxMnJ5bXpdseoXlIEi7jemRyekvgeUyNGcDiHhxfbV2MJzY66dn4uJeWYaWLx7hESVBsw2WsF7xK9OME5B8gGNjo6MRXr7TZRA0tddczXh6ZnN4CuFc6OS0kft05fXypDunobjsZ+4qHhboBNhwtLacqIeW77fqAHh0jSD4FgK7dWMR0dpE+cqluumEF09ErxxAzXh6ZnN4CEjklB1Ds9OhYd9154WtE857V9LRvUxEUi9vrbAqcsWZIpMPNYz7hCayIqXduc1lOdR37e3Kq14KbDyZyxksjk9Nbgj9iTsPerrT8oegQVkPnFiKlyemprKieFYOBLWZpDIpwacC1RIqWcSsI4cpVdle9ajx9m05tykcuVWfFBU9eeYE31WfUFy7j5ZHJ6W3B76KMQ7DCYbhyzKLsttXUxasxoPrRR7bon4mbmKypboN+cd7VC43Pmn/DQKDpVkA9LZ3qybvaIfu56musejpWPX38sX+Fl0m1i5rXkNdRXWYxjpd5M14emZzeMlDXqguEHrPg2HQ4sMHxsc+TqU0muiMnIvNJfNFVqEbOuDEk8eqnlHOql5KomFzJqgInrFx5Ygsm0uoM9xZoLeqQTbiMl0cmp7UGKg5BLWw2UDevd+6fCLLRJHUldJb7s78smnHDgGEunXfC2fUa0ZYlddV9Y/7S9PRcxpLqBGuqPJ/x5sjktMYo788OlnGd85mgXt9nG8/VlaCLQbeDv9wkbhgu0LB1nJWERD6LQl1riIn3I7lZeF1c1gBdufxE9c2RyWlNkVT9cmZMU3fvxgyCGvpUA7p4i8nIn+6t3rGr0w4yXhNLbokdyZS5aNOZrNiBjXsnukmomy1iajLuRF1J7pmYbg6ZnNYctTSK4X+8sc7AOa9E+GRNkRSNw18kVqjcOG4YiDEJVjcB7bJAnCym4fNjm4iY/GVt/zJKuhkg9yz7m0MmpzVFtAveVIeUfC6UDubOVfLk0TUW1HHPran0MuklQWXcDNKgdj1ZTKd9mzzv2aI/TNaS6oP5SzivrIwbRSanNcZS36X7NJICgvLB7zTlgEl+xVnfRr0zG/mnhNTFSzEUgj+Pmn58J2MJl8lVoayKidMQ/Xw6sfHpuU3kFoORtYp5motWjvY9ihe0UazShXGINR+4jfJnclpzpOqPZqO7dbnrBpSMpcVYBHXet0LdvPn5ub/H5YuYpWajfQW+jJ6xRCkQdYnZVsncHXIrZv4KERbq7OzUiuFAd4eZ6oQQKWDau2ykDxksjOdKp1JjLLqfyj6v1dOTTPfjpzz5hsjktPag+iGlpBCQUxAUjYJm0WASYK+nLsczm12cpcXyeQ2mfJqXtMYjZAAnbFwQU5Wg0jnW+WaBOEh/xsqVgwu1SxGThO/L6XoMyV8mrdcJ6T5guGR81c7KZGHv86ZXmi9fa06/l9vXRyanewLUoOocsSNFmc9mNlbXbnjUS69PTGeJzDjtf9o6q2VcEaQcGxAz9WvzhRWjiY1Oz3zyK+N7rA4BmbHMjbfJMl64h44ooxOxO/nIQdK+FLHcJdh/c6lkcrrngHB8kLxes4YUYjEc+6Dt7CStauBLruiOlydqXkVqW9459mN/15GWNp3brM8nwdO35JjsWn3I8JifxqFC6TOfyEC6JlngGISq1etWbzTk78pI8DdGJqd7jtTpE6QjWErMhTIR1MwHcNPqi7wwzD2u+hSv2uAeG1xmYidK7zKQpWSF5CPrk3XdJ3wZRVZobYbFhJwSKT3uaQJpKkvqykFKPJxhvEn7zYY12m1rdjpOVDeFTE4PAjQ0FIcVDVSpNLTR2O/8/pb8MC2oT6jHSkirQAqJoLUtZH36cid9m/qqAn2zSVrsrwxJlIyS0L0rJ0upcGJqWrO7ae3tLScnLKibQianB4HKHY19/tSweMUFcpqqizIXQTHIG3jsloCXHItJzucw9QeymFieJi0QV2daRjn7/nFbTJdIxFTzKS0F5NSsW2Ozaxt7O9bZ3bG6rKdFXSdvSFyZnO450AMqEUJKYwALKQ9jTAzszq0+ndqE5WLleO0iJms+ari5tLB6reEfmPCPXELijNEhMwbFcTTHTEwlROKSxVzkM5NIpjp2YjrYtfbuttXaLT8XtuZNIJPTA0G8X8fguDtvU1IgNbaWNIYVGofHJzY8O/NPUvk0A1z5x//S3WeslOHyMPawLSUvLCaR0VDW0pCxufHEGM7lU05OXsAfIpT7DxgUM4rKJggmHL9Y5n5cq8tC6tjG7q5tHh6oS9cVizQI4VZVInNXvjdGJqcHAe5qpSqVDetSRdJeXRZCTRbCgo94nhzbfKJu3mKmXg3zoUqCKrWSJEglpVRBeH7ixJqhzGNk1SmYMoqMIZ/FdGLzi75Nj57b/LRntdHA6ky4lCyIkZ5AabcixQcLCQjVqYt8cJSXG1tR3uTQq5BCrdayRmfLNnYOZTE9tUZ306zVUlcuPcNL736ydzPI5PQAsbwT+kG646EwDXXxFv2+v1E/PZcFNRlLA6vrkztFPQhcloO9S9bFaiwGrOzQ81nfNh45MfEppzQpM4EmmZrlwwd0kvTF9/SXgFeyiLSVddTY6Fp7e0/duD116URMzZaixPQByCnp2U0hk9MDA8rxCQWRB7TDjZGZ41M1ztHJmXf1bDz1cRZC+FyoJatdg5vUvNsCZSSfntdEMf6qBebgbOZTK8Zn5zY+P/eJq94drrpHCNeLsm6RVVOmU0Nc7ZaUbm4F85c22tbc3bHW3rbVNjs6mc65lRm4YfFlcnokCAWsSalYG8ouRj5Zk5Uc+V6ez36uqYvn5KRGrU2Vp5JvSgO3rkh5LHNbEo4/cVO3trhIS+ryAi8D4TwciKkVj/bppYpMNw7HqzlBTi0ISq5Wb1p9Y8PaTw6scbBr1m07MaEDpT3q7jaQyemxYHmXk/ktrWKQvDFmGZBzGx0f+0ut/oSq0rVxrGheKONtKeSbIOVLfyKcRDoiJQa+JzP/kvLwWF05Xu0RKTGbnjk5j31KRcgsvS+oI4icE8hExNTc2LTukyfW2NmR0jR8qoBPvizDJI0qccNizOT0WLBkExSqVCosB1lNTNYcnZzYfDBwi6La1fE/b+gpiXDriGgo/twIkmVpY8pHN04WIi/y1orClzuhFDfclu4lkgwkCxecunAin6n2i1ZThLRl7f1da2xt+cC3McESQtJ5J/UyfribRianR4T0siY7fiSnAzXixSQ14BmvbQyGPinRyamC1Jw/6dYOyjfjTDyVYxIqxDtR2QoRE19LceKNbl+GAxJAJEhkqp1Zp2k1EVNzb8ca21tW84Hv6lt1KY7HK91tIJPTI0EoEerlk+kw40ut9LfxZWHMZF34+uQiqLkasltMKyQF1rZZe17l/HWUiU3OL2x0dublubLWuraPuSt3BRIHLzw7OUkkRatujd0tax3uWV3bRTtZTImY9Ef4FbdEKNkNIZPTYwFKVJINf8xjYUk6/hpqqG25JmMzPcagmGrQl6bKgirD+Bwhbfn3p18lPNm0e/tYuVC6dpmDknh8jGk89YHvEV9LHg6dfJkygUUVbYfPbT14lKIJAkmH8Zf2E+raE/Go67a5v2/dp4fqynVt3mwsZ31/knVSCpeuuncz0M3EazXjJiGJXnmiVZKC37mLuY/vjI+PZK2Mb/JG80qg0nFc3x0Hvq8m3BBzbbStsb9r7f0dW1Tms9A19NnCClItY6Sziuv8XgsrGWaXAVwnHGSLz4yPXI7UPZV8mXBKN07hlsTF/iNCsmySwPy1Jt1VgpBKMUqI8qmprjtdnyrQ3Nu2eqet6hZh6YaF87AeLcV1lArjoi0lS0jWdeKJcPJ5M2TL6ZEC5aHyQ4nQ4UQ20jZZTPPRyN83Y8E1BpUZPF+SQDBZiZtQxM8EFykvVDYLz4vnSc6fyF0MlN9Tm7Hcicrg78hFOI/z+FByk/80dOCfRtc2EYm4SV02rKTW/p61dnat0d7wp5gh8GV0l3pZ90tiKs/qEON0xnI9ZbCbQCanjCtA39ypwc9HE+/mzeSwSBhQRvN8HpFcqZqO2N4mIm/kAefExMD3ZFq+vHtuE22LWWVAP7aPEC4vtnI0dKaQ+PcPMXvls2g0rL61aa29XVlNspi6HVMfX5WJxaQgLusKnJRCnikA4p1O5zYcTG04nN2ouDM5ZVxBIoB0Z22Ki2oXY3+KxyL/jN8seBfPRyFKcpAyrurwbSCaReqWyHFtn8PEOkwlMTFOVj5phFzDPVa4pFRBfjORHOL9Of9rNK2xuWWdgwPvytGNXzQVrJxg+clKVTrLP5JLxDSbLuyiP7HT05ENBhP3uylkcsq4AtctKSaK0VDjZ7JmjblC6t4xWXM2VJdpMXOLBU1M1ksiqSpcgUt3U3BSpP/g15TFxLf7TplceeLrpjeKNMPZ2xYEW7pHS1AShN9s+HOhME5XduW6m7b59KlbTenlXRnGkpV6fQpbBl7+RjrJeXcQJ3mfn0/spDew8/5Ico7QN4NMThkrQAvTXZF91M2fzhVzt5wGRyIoBpt9sqb8l04/bOOwdDcF5Uj5SGTIHCaWOJn0zmwgqw7rCX9/5uRPFa/isU4boH6ouzoELYtooi7bbKNl9f0dax/uqxvXlWwaCpgGv5GSu7LyYsuGM5DPXCw2F4NNJguR0sSORUyD0TQRmv5T2JtBJqeMqygV0pVRyubzodBSVi8QCVh/YFNZKnSligldqIjkurlE8rlpkI+5zQZDdePO/AVeVq1Mg/VuE6ixpZAZiVz8xiLinumgEDE1DnasebBrta2uWTMRE7Tk3T2FrboqRPtyde5RNhoV1usNraeu3HgkC7a8H1z9AsubI5NTxhXQtqN9++NnOUx91JOlaxvTmS3OB/7xhGm/L4LipWGUshyNKPXzxomKa8wSMTHjGzcfpXW+0yyday78yOF1iVggoE5bXTimCuxYbbNr81ZT9YrUPJT/QgaJlPiRq5ANe05Mw8LOzsd2ejYSSc1KYqIGCFPqwA0hk1PGFbhyuktqhvWEwyJhsqZ/QGFapMXaTnsiqDMrZL34onU+84iuVUonKXoFnuDVXXQ7goVf1d/bBwPfahmsXMnYF6/a8GpKw8efkktNLMV5bHA5lfXk5ZfQvPsricxZ7qTdsfbOnnX39n1NpkUjEZOTExXrIQOKl4TuFRh/jC8Nh3M7PZ84MY0n0gF18RbGKphOa2X4m0Mmp4wriGkCOL+vate7BumIjpMrdJMPTV6c27R3ZJPzYynvOBGUO1kzIpTUpSBuua06AQLyyQk69vZQbvGH5vwDlvJgMiUfaJgdHdm817PGZGxtSGk+kwKnuUxLkvKEHgG8G0bzTeNFQUyQDI5VF/xDBCKj+sFT68jVm9o3de30i6M+eckXeXtkZOcVLrnXvAaSUwCspOOTkbpzEx9vqtdFcIpfqzUVxR/z+XVTQjeDTE4Zn4pQ9qR4gnZc/bjjSpmZoDk8OfUvDWPZ+LIrpVqnx9gpfIpTOiAP2gHzzsubt4N9b3I65+TGE7n+hV0cndjIZ32XBCTHQO+jhYqObAHzl2JyJX6zes3GTe1sbVp7f886fICgKQKRFyKjE0fURG3undJaupL05DmdLey8P7bnz89scKEbEI/plEhBf476cRDp5pHJKePVIV3kpu26yZjPeGbFKR+jVBfvYiACmUnZ54mgQoNX9HfZDjiNCw8d+JM3pXu5nEvPP93EtdxKKvGYX95Nki1lJalATohmLmJhPIlVBXh5t7W7ZbV20+srVq90USssXXQci8zhUmUgYTlF4PnHRX9mvZOhunSFFeraESJQJz1PDcT25pDJKeO14F0BwWcds6TraGLFGeuTswqALBx1uRap07ZsDKuoqrZ3Kego0IegGzcalx+5TIRXiyV1M5wgkivlEWJh4FsWEsuctA72rbEji6nTTu9KOjGV4YSQvTuXa0rE92QxTSZz6zO+dDq2iwvdfIpkSRGAMOnGgLs9ZHLKeGVcqjIKxHKuC2uhuKyfdHZuI59NzsJ1TNYUOdEVKGN9YkKkH/IjUqKrADF5Omciup6I6cIaSqdFPLlq/Mc8+zvJLLrPEp3IZyGLiYXhuvv71t7e8VUG0hM5ga07xapwSnnWZUk1LWSBTSeFnZ+PrdcbWb+vm44Tk3fAPSzwsUCv19tDJqeM1wSKWtFyunfoqohkcn5uF8+e2xyLZyrrCSV2zU9Br0BJuLUEMc2TxcSrMmP/+q7iq4vYUBP0l3gJ63fsxw0IBSlAEDwjnYo3pq2G1dWV43WU1ta2WnZDssKpiUtmku4V8ZdGkJBS8wmWCsTLuye9sZ14V07Wr0ipVhfJXVd915nDN4hMThmvDBoGRMToBXfjuQ5wCzkeLLeLuTUGI5t8fOQvDs/HUxGPIqHL3L3ZpXG48yP9z30VTqwlVhZgILylM83yHE/uPGKGcwLy54kcL+ouNlrWfrpn7Sf7Vt/ckEzrPjgeg+Q0chz1hghxVAfDVGmoSnWocEyufPb8wt+Tm84gNWqgnmRP5DtGJqeMN0BSdRScxes4gnro5jWnUuhhsoIYN2IJFkiGUP4UT3t+RPdAXblZv++rcPLybo1pCrFyJU6h/QHSW2ggbxOp5MkF0vgQgpBrpG/JbdCN29mx+garCuj24NYlHe40+H2JlFqSvn6VFhbRrFjYYDC1U3XjeFeO8SYWoMCa8q6gh797ZHLKeE28WGG96eh0nfGjwYVP1pycnVoxFkHNeeVlnkiJxuHENPAlghkA5wkdDZD25c2ILQdXW9nDhfOGS9BdKn/yDl8wb8qm7G5ae2/fOjt7vlgcn3HCakrxUlwiXu196aCUPaAbdzGYWe9sYmf9qU2mEBaERMj097aQySnjDZBU2MlEu6lZpIaBNQXq86msJllF5yc2PutZMRn5VAN/V08W0oyPXJ6c+rt6tcnEZ32npqGUaZROTPhEs3zgWBaTHRfA8nApj6Y6dJub1tg/FDkdWr3FC7xNBVF3joAlMXntaMtOIij9OCklcoKYBgMGvoeymCAmrNmGKg3ri7gp7NtCJqeMGwFt4ArwkHKnJ9isIjCyYe/YhsfHtlAXDyIq1JUbPj+ycT99fTcwnyfL6rEi+Ihxpab6vnzcEs+ZjsdNNdntTesc7Ft3d9dqrXJyJREqXFLZLeui3HHLqu7dNtZfOjo6t/P+0KYiqrgBIP91QCanjNuDN4q5CGphTFhuqEVMez0bP39m448/sunRkdUvLqylxsB7e/Ekju1jfCoHmfg4nFssaSZ8GjeSLCSPebtl7QMGvg+sKYKqQVQ69UkSSg07JlamMT7+ZFHJazRmVYGRPX9+YaORSGkue6uUOTeFdZF9JqeMWwONBivA24yU3lcQYH1yEdJcVlNtOLSmr/XtIYnieIzEdInU5aqCrlyt3baOLKXO/p7VN1nuRBZTzNAuNxIcwS8P5ZyUfIzPrJjz8u7Mzs7G7ng6N5+nF3d98Hvlum8bmZwybhV+ty73ISh/XWLGeNPMv77r85cqjeIxE1OUPJGKyEQ7M58q0Lbmzo5t7O350zlrtERYbhulwHI+FrUCl6pk62nJJOPlXZY7YYIl+4W6i05MyyuvFzI5ZdwaaBQ0omhI/pdGWpfnfXRjPdvGWwGSwkEpRUOk0mlafXfbWurO1bfSE7k0c0nEEqJ8EaFLwDxegJjGk5mdng7dDYdTWUzEYXqrJ+DBwTrdHDI5ZdwauCOrI7d0fpd2slKjkWNuFC6e7D16iEwYBMeBeathnSeMMe1ZbbMjuUHuDauVAoPYw5VRrkLhMUp9uZPjC+v1LkRSTGiNulBc3oEs55+tGzI53SVQFnfrqAq3CRoThU4ukVbaukMmKeCjAGUtReEOpMFvzkk29YbVu5u2/c471t7hiVzbZcSTNu+ksa9w6RdHijxt85TLXxF/kb6Mcnw8sLOzkYiI5i5zDEvW0xAB8Knxcv+VwUVuEZmcbgn+wCXginWpSsk9fHhJJYfkllTkx2EhLM+nKA8bSzZKdIIDSTUgm4WspZYtdnas+eSpNbfVlWttWN3nMPGyikIoHEmkVFJKQfWkyC+zvpka0O9P1Y2b2sXFXMcKNeflXWZCpWZPeuXMKD96ZbxGlFdBJqc7QihiqNOt1+yaIJU2lTgQpcehgI9DEgEoQaQghoGUUQzvmkkIi3bLGtub1tzft9burtXbHRk5IiVZOsRxSZUbEIRfBVOU+MglqwnwAYL+xcyJibcU0yflU+SUi0isTHDNkMkpI+MO4DwkDnCrRwesg8XkSvZ90LpVLhC3v2cbO9vW8JUrCZyI4xP0EczmgKLqPsg9KYnp5GSg7VjHLJucwty3J6GZnDIy7gg+GbImKsLiwXJyypE102yJlHZ9cmVDBMXrKUE7q3OPiJGsJTnSc181Y6XHe3FnZ1M7en5hA18gLoUGENONz2O64eRWkcnpDhAqxC1s2cXBSw6liTvauk2Cy7hZBFXEtwCdO9pN6+zJWlJXrtbZsEX5Xlt15crQCw7dlSYYL+jimCowGM38HbnT3sA/QDCnG6fmzajSrVlMt5RsIJPTXaKqJNqNu9lS+W5LiTLeOqhZemJYS6xaWbRkMW1uWFMWE9+Tq4uYag26cjTJpAdoRfXmFTe0tIvuKJ3CfBndXm9s52cTGzsxpTTSE74U/j4ik9MdIJnvJaQwddbhkav56wdStApBZTxMODF5FauuG7JmIKYDEZPIiddRfOAbK0eEUx3mvk4r8ENdZjPWYUoW07m6c+OJrDL/ksGnx78vyOR01xAfNVsta29uWt3fj1IV+J1R7j5rUsZnIt2KREGdtrX3d9xigqT8AwROTImcIDFU4YUEI4+C5U6GIqaTkb8nx3gTX0whHR84qMXEyk/EvjfI5HRH8C6c/0no3Q0p574/Ml602vJoqiLKpVVdlxROGnq/VeuRoayoqDOfGsCeTJxkMYlQIKFu17pPDq21K2JqtxUikYkTSgn2kvOU3PnLu/6ndOYL78qdQEznYwVs6jzjTzrvFjjX1eaeI5PTbaDUrkslKx2zcbGUeBojgqofHMq0f2K1TtcJyuezSMlQaN/4LEVFzFh70CXz5sRNyOtMdKN9uu5+W5K1bLt71vjc56y+s2fW6ChMw+qqc58I6Qri0b3KWakhkRNEU5KS3FgW03FvYEdyrGDprwYx61IMGN+fS0kpzfLvviKT013DNQellWLqztnWHbS1tyvzvmsz3Vl9vhwKW1pRcdfNWGeUhER9ydBJdUfTqhlL6PmqAnvb1jnYs9bWlgwdPhwQ1MFfieXO1YqHbvzlXdZhOkmvogx9VQHOJgp7iMjk9Bbg/IPKaafRacnE37bG/rbVtrr+tVZejmWCHl/PyOS03qB6sGvodLHHDaVREpTbMLoBsapAc2/HmroB8SAEvPDJLBV+pdLrVuiQBeIYW/JVBViHCTPKNenhIpPT24CPC5RQDdS7iaBaB7u+LIav4VwOjmasP7yanFBSlwrS8BqWheSWMQvEbbFyJfWaxoWuTBG4BsT3meNuMc39qyh8S240EhH6C7xr0HQranwbyOT0tlBWLHNR+CqrtUVQO9vWPXxijc0tK3SHLVB1xqF0Pk81WF84xfAjx0B4mlypLru6652DQ19hwMo5TKwCgPs0QHFpgLsmi2nuS+ryOsp0Ih1g8Nu/5udXfbu45SxkcnpbuGK+U8u6k0qBG92udZ6IoPb2bN5p+xdd406bsX7wmlM10p2ja8e4oW13rXW4nxaIUx36V3e9qX12HTopieF81vdFYcdHzGGaWDFj/SVea+Hp3uNAJqe3gcRF7sqRCbnyjwmam1JuBk/3dqyhO3DGeiO9KyenumtCTAeqN8YQNzq2cCspddFfppsO8TC5kqkCrMN00Z/adCrCspKY/KaWRrgeOjI5vVUkFXN9S3v6l+O79yi5ugU+H6bTUXehVHL/SyD2Y1DSdUDI+hMy54A6w+rd5COXO9ZU97y20S6JCVIqxw8/ETG52PN1mKZ85HLqkytZXWDKN0i9xqu1Xt0+XGRyeisIe0nij7spW5RcJOS76h7wWkPjIE3WtPKl0IgDoaHW6U33h6+obw/UD/VVTpbUIdL2MUB2GA9kasDWtrUP+GTTrtVbaQ6T1yfx2QS8qvjB+pn7L2mldZgK61+ImHpMrhz5mFNaJZSL+lVTVLnLW9TDRSant4SkXBI/FhHO30LHpXN+Xt2EBV92ffrUx6HqG10pK1Wms2VYf8NdPuhsxk1DAnZSSjcFCCqth54eYiB3PtFU31E37nPvWn3/wKy9oWjx9d30MMOTCedwSkp/EJMqb1rMrXc29LW++xcThWgmcnJS0pVUzymJUjceATI5rSlCl+tS7oasKKYatA/3fUGyqbp9U52kATTnOu930oybRkkLvsU4Rc4NrFb9eTe7y8u7e9ZRvbQ3NpyIEplcA69QnfN33rxmlXBaII7JlZDS6enI5zNBShmZnNYaoc++32paY2czDbbubtlcd2ye7NT4WmtW5hsHYnfnhFJaLcgbWdcaVu90/IEFkyt5V9JfSxIxxVPVTz5dTRUZ6SqEP5Hjw5YnvqrA2OczpU82rcZ9nMjktM6gXYRSo+xtERTfyd/bteY2KyamjytCUmWwjFtBohS/B4iEGiIm5jA1d3et1lVXu5z1LUYqN9eTS1QRVDctFr6qwOnZyD9y6eswlV/fzeSUkMlpXVElGyk7DcMna7Za1tzasq4Pvm7bgjfb1WCWiq+7d7iM1wf0kF6kTcdMrJyre13rJoupc7BvDXXleEjhXTwFhJReSEyqDhxdttnMfB2m097Ina9cuYCYILnr4z9GZHJaV1R09PJN8/K30XSC2njnqdV3d0RQvI+XiOlFjSPj1ZF6dHyEcu4f/6xtbVj7yb61nx74cie+koSa0Mt2qyEnVq7kk00+ufJ8ajMlfDngrjCly8jktMbwliHSSerqz4q0ywulwIcmNtreWDr7e9asTNb8tDt4xisAec/lZJl26E7z7uPOps2byVqial529Qjvys0Wdno69ldRBoNCFhQD6DHrm0Ri+P0zElsX3HI2MzmtLRhtCoLRVo2AI37ToKyqrhz/aMp6au7xyWo1HF5x4Dy6XiqPH6bIGSUSBYRQkkxdrpxgI+drfTeb1trZ8cUBG1ubPnXgcm1u/yl/Be9K4+ZuxbrjSNvJZOZjSzyRY1UBBsN9fKl6EyGwUPFZb9xyRjM5rTGoe7oNqZrSkQPLiH0OfRyka3VfWfPA6tr3l0yXcVJDi3aXkXBJTJfdMveRbDk3ZxyvI2sU4pdcG9vb/llw3pNTDP/zf4/k0UskYvKtflm1cjSe+YqVENNgKGIqyhuPxyNUuEjqSoKPFpmc1hooaen8bn3paETRSPxp0WbX2gf7fof3t+DLO3xS+YyrKMllSUxy2kIYPFwomBDLg4ed7TT5lddRmi3JPH2EALk79ZdREyRpuuHlPlsspvGEdZhG/hECXkvxiZXLSIQKmow8LRN89Mjk9ABAJfpzHpEUX/PoPGWy5qZNGzWbLeY+lMECaJ81LvKYkMaLygNhQRdOVuiErpiIiXcaN/ZE9iJ9n8PkTPQCuGAjMcLVRUJKa7oQKQ3s+Lhvo9HMyS2dfyC4ZX3K5HTPQbtwxwG12dSd3d+M53tou7IAOjqXLIRMTiVEQL5Gt4ibFsbDhULkU4iEeJ9x4+DAOru7vtwJ+PSHCwhVhCbhem9O0mblyuGIL+/2ffXKWcE4YEOExfkHhFvm2UxODwlqRAziLpoNb2RMFNxgoFwExVpA1bv/Y54H5WKQo0fHyJDPYWIlCCcmWUs7O1bndRRZovHk88UEJXnTVZODfLCWzvtp1UpfVWCKrEVObjXl5vYqyNK677imzTBrnDES5kL5NAMsqHLCoJ8viemxEhSl9ldvZe1ATAsRE2todfZ2nJh4Alqrs3LlVUK/jqQQIaNGjCUxVYCXdk97Y+ufBzH5JBCFfBG5ZbwImZzuPdQ6vL+WHIOq6U8ExffwNjd9VcbG7rbV2nz1gwZD2McLSp+6ctpXN7jR3VA3bsdd3b8jCCkFoXw2qTDwPZXFdDEofLkTJllOpyKlBcvpQk5ROw8Mt1ygTE4PBFgBPAdKEzXTPtrDQC9vz7d5e35/15pYBaUF8OKuygMHxZZc5iKm9g6vAtGV2/JunJ+kvyfxOYe/RAMssJhESEfPz+1CXbkZrOfrfENM2q/cPB4UKOYtIpPTvQc0hJZQlelunx50y+nu7zRFW5PVVNvdtQbrk2/vyHJQt0VdDmY4e9tRSNaG4o/U8HuRW2eQPcobSHlGAElGdHnnsoxmfIDg4NDah4e+giVzw3ytLBF2koLvJniZPWV3WJ5YS4XccDy13unQjk8G/jECfxUFuYcQiePxM14VaHHGPQd0xF8iJG3DKiq3zMvxx+FYTTs71lKjbG1tl6sapHA0xzRtUIfaeNu6xoF7QVByiZjKA+Wep2gFBNRRN27/IM367vLJJrq7kpLLQv8uN+J8EhCTy0pp8fJu73TkKwv4cic+vhQR04U5om7iL+PlkcnpweCTip8aRulobbIYWI+8sbPt31JrbHV9Tg/jLzQllIGwIOKt4jq/dUOQK3DLUVsmDTDru9buWGt72zZkRTY3uv4StY8vORuVsWI3EnGkdEiPV0+GvtxJWodpNIKYCFyVIKEz3gSZnB4LvMEufDXgOk+ndresebBrtrXh38hDFRq689MFSrbBi5vXJ9rtGsEpgrJ65tPUioLJqKzJvtHxj1xuyDWYw7RiHr3wQcEyWCImFohjxjdzmMYTaC83o9tAluojQZVQfAimpca6s+kD5cyGtoa6NiInQtFEC7VuLKqwqu4LIKU6JCvVxsphDawZFqOIqVM+FICkICa3Jj8LZfmhIN6TGw6n9vx5WlJ3xlrJPJFblAPpGTeKTE6PCNF8/J07nCwmBoM7Bwe2cXioLs+GzeVH98dJqXROUsRL0RPWmLHIc6HtjK2XsWubTw6tzTty7UZ6gskYnJDGly5dFU5KjDFpZzZdyFKa2NHR0Mea0qqVkpWTYMZtIJPTIwML16VmR2OUhdFs+oqOLDnLYv1YGKz4CHn514avtlcnuKXXGrZK8u1fRoFoWm1rbTNVQNbh9qbVmedFF1bnXtSDuwKFIRxzmJj1zVpMfOxyxtd3mfV9ZQA846aRyemxoMIqsUvnhz8abK27YQ3mQe1uW7PbMb6b55aTwkU7LqM7qvvrBPLKe3KsKgAhbTDrWwRVbzXdWvLyvkTuSSetwzS/XO5EFlPBkpiymNJAe5JO2j5G3K4WZHJ6RIhmhEpVB43dkhAZmUipvb9nbawovigi0lq1MDjEj+3tquarI8aYFrIG+QCEl2MrTa68tHASPX0avIxzZn3P/f04Vq68uJj6ypVKzNNysXhCn+jwPhKEFKPssf0s6b48Mjk9KqA4OKo99kvnGzW6dscaeyKo/SfW3JDFUWvJTqi7lYX6MVFzVq41QpQ0I13717ibhr/577lgJnzpRCJcC1+ezM1lIfm35J4c+pdqWIzPLSZ/r/Cy3E5RxHP2TY5dnsbNC/N5S7wj9+z5hT+dK+ap/HH9VEDcI0JUqndnJUsdsr76wkf4OJdke1PI5PRoQHOEYsoGStdHbjkYXJ71geJm2+pb27Zx+NQ62+lJHl+55Z/B5PKhnoPNC92Ntl0SExEpUdIGnr7y7mNMyjffkuseHviXUfyJnM9hSjO29eNh3bEvJoKYOIKUcEysxI/VKk9ETL2z9CrKvJz1nS4s9qohjRQ3Sc5PPHz4AGQpS/Z1V6r5IusipxoEBaiUmwFXysjw5rV0asB1Bso3u9bc3/WXhhedls0IKN1rVOYXsLk5dfx0LF9D0QWhBmZ7s2olHxzgqSNLxLDed4NXdWQx+dM3OYhnFW4BUVhHopq52Kmv7htzmM7PJz7elCZXLgM+ciRZ+NpgXgm4me5nhbXadet0mukh6A2Jq6Y7xTVVl/FoIXVIXRdBjXVRzGw+Gtr07Nym532rTaYip0qYClZ1khDetm8IqUH4rzbJWmKsrNHt+ou7LcaX/Dt+rMN09b77iWkCvtCc/Eryms7mPoeJgW8fX5pynfRQICMgmXq1O5VrW1ijMbeNjYbt7HRsd1f1wPw5utEEe0Nkcsq4CleHRD2Jgljmd26L4dhmZ32b9c5EUCKsNNHAQ3kjV7zo4IRi+tkbbNx044IwsJgY+Ga5kw2+vrvFO3Jp3XRf67sko1DvT5ATudM/TWw2W4iQJm4xDQZTfyLHNAGIy3GDZbi/kBDKyoSYmGhSbxS2udkUKW3YznbHWiImQiRZv7nQMjllXMI1gR8oKemikxPEw8DzWA2317fxyZka8EgNmLEGAtLKoY00blVVy5TGzcDnFUnxmSrgXbmtrm0dHvrUB3/ayLX9rn3ValolKC+h/Fi9EospfbIpERMTK32wV6kkur2p3N9zSFbenfOBPtZDn9nWdtsOD7dEUC1/7oA+NNxqRc5VLXg9ZHLKuApXBzVcKSGNkyNvptqpFbKgJoXN1L0bn53YdDQQKekOShcqyIlwHodUSvfmeurpMDBdncPkq3z6p7B0fb9GIhUmgH8aPC2xL+/F0Y07P2dVAWZ9J/IjDcJQaB/nSok/bkggbjFJJjJQbbPbsIPDTetuyHptlDck/bjtVN4E3hSZnDIqQBXClb8rzLIoRFpTWVDnpzaRmw2HTkyQ13JagcJxDJZj52+orxDljM9/t5n1vemvojBgT9cugQbCRUSSK40jVJw7Ovu8I8dUAV5HOe+PtV+ImHSuHKdyu9G/vks58ntzCbIpa4W123VZSm3b2Wm7xdTUnWApbtcV1RQeNyCyTE4ZFWAtoQ5QAdDvUjtovM5Dgn7GQyv6fRFU36aDodXUPWpIlRI56YdwZXTclaQE0sd50NhxlHfhpT9brq3uXEekxORKEROTRHk3MFk6CU5PykM0jk+qtghO1h+faeqfT+2sP7WJLEGIiakChE7lf2zkVJUTZU0kjhy9LuWwmDY6NdtWV257u2PdbjOtcLEUjXY8mUxOGbeE1JkrcUVnQ01TGONp17SwYjCw0UnP5hdDaxQzkZPiyyXrg8BlPHQXR1L6wUZxIpMrtOPLDHPMH4HkIB6f8U23rd2yBt+R21FXrlzuhPR8Eb2AqzIpEF1/pWq7xSTfQlYf6zCxBtPp+dimPjcinfPrpUOBvTKue7jnA0VZV15erxXJnwcCyA3ywX+O+G1/v227ux2fMkCAmltNSUJEJ6Tv35C4MjllvDJcXfmR6tQLWR7DsY2Ojm12caFjEZRCMDiKjqLbHl4HODzxW3YB5eb1uRMNAVF1/JgKwFLcTO2riYy6BwdWFznV1a1zYqJx0DBoQRW4NuOUCGH4I1UaXf9iVs5hGpczvivE9mghCbmViJwkDxET5OT1IBnWda7emNs7T7dtd6eZnshJnMiWKQO3iUxOGa+FRAL6gQDUVZqPRzY5O/W5UIvJ2Joor/eMEj1APpCTk5DgBCSX1JsQsUnWEi9F0G1jwLu1u20tX+5kQxGIkRJZJaYExVM6nj8SVBjGmPgAwWlv5JaTDL6yK3dd/MeHVEPAKQlS0L5ISXcPBrz39ru2vdXiOYSP5yE2t0YV7vo6uBlkcsp4daAxrjUl8fA3lwU1Gjk58TSPeVFNHoktQ+iXGzPbUp+doGIrR/eKc8xhYqWEJrO+GV/a7IqYaBm8jnL1bv1Jy8mvkNLSLi/vDsrJlRBTMUsWk1t+V6M+ciAMl5q2c2uImBjwZnLl5RwmyMgDL5HJKWO9kNp/2hWrYOW4YouM5qOxyOnCJr1zM1lQtTkDOxUVky5DQFWlq8uK4Y+m4ZMrW+o+iJASMW1aTcfE8/fkCFk2CFQ37uAB39MPWwa7me19dg4xxeRK3pMr49xeu7pfQBQuU24mhSHubrelbtyGz2VqN5O1tIrbJCaQySnj1VFqDBt3mD3acwsIghrPfDb56LRni+lIfowcyV7hfEkMEReCqLOqpPzTcidMrty0TT7A0FU3TsfpiRzzl9K2ilViSsd1JyamCZydsQ7TROeUDqbbiuWVIZFIZAx8+wTL2sytpb29rm2KoJoiJiSrmtH5yy71XSCTU8Yrw0nAf1HZBG/yqBL9Jf6Luc+Dmpyd2Gx4YcZUA5FLDIIH2OUbeny2iVt2fOSS9+V4Soc35ESToGOxiivkpH2a0WS68PGls7OhDUdYbiImxU7dSU9RjjQzUSELxphqtUJEtLCtrbY9ebJtnY5uEnC5y0rb5Y3hk3VwW8jklPHKSMZ/oicIo6GdaPf44byrN5tYcVFO1rwYWm1aWEOR/UOeZTgwqTesvtH1QW/IyS0m+fkiHApIaP/z/atwQipVmA0TKns9JleOfHndubpxTnweURePJ1P+RIpu4mPAUgDXwEfgrNNOc5h29zdsQ8TEYLgTkxNXspguCepukMkp45WBwgQ5NaSsWENVcAgF8A6WqVtXDAc2Pb9QV+/C6iIonuKh4j72JIVfbG5aa3fPV630TzY1U2NIaXiz0N/lRXyfuNrgyztyRTm5kmkC5/1C1pNySDeOpucNjLAlMdGFcTPqoZMTdRRykyyS6Yjo3CEHnj10NyCmlpPTxgbLniDvUlYE0x9UddtjTKvI5JTxynBCSLuu5NVumnsIHoYXgyGo2czmg5FNTvs27w988qYzi/oNdZFRQ9245va21dsdn9h3mZwSi/bgTCS3vBjNTmHV4FhVgCdyfRFT/2Jik1lqiJwnMWKkdpUaa0qS30j8YeKSjNkgE24lQTUiJt1VmFC5t9d0cuq0sZhK6VypVEUlmUxOGQ8F/hwPgpKK+UvDIpDJcc8mw6Gv0c1Mb38it7/rL/Neme19DZiukCygZA+4xaT2xxM5VhVgW8TKld4iHzeSlCSgkpx8cqUEyBgTxNRWV25/f9MnV7KPbDkPJdw1EV2HTE4ZtwafSLlgyRUUTU6EtJjObHh6ZvP53FosErfNBwhEShDTZ7YHyC6pK/f+mXiPaQKnvUFa57tchyle4H3sqDZsRJuMIZY1YapA04lpm1nf8kjExPn1QSanjFtD6lSIRiCm0mExzWfTFKChbgYNgzGOl2gZEB3KisZO/MsoY+uJmFhhID7ZpKvE0EoGwirl6mNIsmJZxIGxpb3drs9lUhWUY0zLoH4DyJZTxoNGOeLhWA6a+zYd+GC4tjSDcqhjiRepJZPOR+PCx5bOz4c+CO4Wk08LwPoioevjPjpIDC5WvysU/voJS53s7Gyk5U4aSej8rgMZrSKTU8atAcWCoFz58QB4VtpBHK42jVW19LSU2ERWkk+uPB87MXk3jsHvkujAalqPFlhAkgrjS8liasli2nCLKSZXEgaJJXJaL8llcsq4NaBY3q1Lh0uksY8qFGIlUFUt2ePLKJPxwk5ZIA5ikvUEKWEtsVkO/gp5cmUJdYMbtbkvELe907H9/Q3raJ8xJyoB6dHNZta8d+zWzHrK5JRxi4AyUK+kYq76oW3hjfPBcBoHJxJQSxx3dIhpNJ7a0fOxXVwU/i05unG0Kw/rEysLxS/JKa9eKUA+c+tuNNxa2hMxYT35ayqc864eMgrHZr1klskp45aRCOMKQuN8qwahRuEkxnFpVrlWyr+YWVpVoDewfhAT3ThvYh5bbYw9HNfCBnjollMpI/+VBEqSgVsYfXOiltW0uSli2tvwd+VabeY4IVIkBxTO4wlrRkqBTE4Zt4xPUS8/lYgJSgkrK8XgyygLG7CqwNlY24lN3WJK7nrEtdazsd0kkpRUThGMd8ncyZ5kcbh6IYupJWJq+zpMvCe3jgPen4VMThlvHahgaloJvG7CrG++vptWFeCJ3GcR0+OCyyosJvbZEzE1GwvrdrGYura12Sw/clkGuGfI5JTx9iEVDHuJz3/zLTnmMDHr2xeIK5gk2Lyug/iIIaJ2qwnwySYRU5NPNrVsf1/EtNW0Rl0dXAW4h0aTI5NTxp3jkyoXHTqzKd+Sk7V0cnJh0ylhG/phLSY1RsaW7mlDu3kgiNQZtsVMxDRP6zDtbzpBMRieltTFpRj3DZmcMu4U16kbPj65cjT1D1yeng2dmOa8rGqsxZQaYgqZAbyDiyzryWLiidwOc5j4yGU5oxVSuqe85MjklPFWUFU7Ptk0GBV2LouJdZgmsp5ixncaZ0oom5z/Pm4glbTOt89h2u74PCamDTR5HSgFSbjH4srklPFWgNrhmMPEgDczvvv9iX8i3NdhKr+y4st+lFMFeKsewspIA9/pI5cdt5gY+GZypXfjYKRqq76nBJXJKePOkYgpWUzD4cSOT4YiqGn5kUu6cTjBSamcXMn8nLn6L97S7rE58MZIFhNW0u5u23b3utbiHTnkg+OvfIrnuMeiyuSUcWu4qlg0HNlBcI3u7ix30pfF9PyIdb6nzBkUfCTFQ4MUn9/k0uTKe9zaXgqXTy4h6kQ0SXaQz2Ix8ykCBwdd//puk1VDacJXuEi/JHHPRZXJKePWkCiFNpL22C7mdbeYzs6ndnI6sfOLqQKUDeyFiHP3vLW9BJbExGh2OVUgubnEVIiY2ra31/HJle0Wkys99INE7sBn3DqqtENjYr3v8Xhqo9HE+PJueoH301rZZ51/SEhlpUebSJ05TCx3svDlTg4Ou7YpgsJiesjEBDI5Zdw50ngTK1fS8GhhNMIqhT1elNSUDkRM9ZKYtmQp7TPr2z8LrhAPnJhAJqeMO0ciJCwmxlAyKX0CLG0MMVn6lhxdOJY72dluWUMmVfoAZhn2ASOTU8bdQlwUhMTysGmJ2ERWGciFJwMsojfxlSsP9jft8HDTLSZmV7iTqB6DtDI5ZWSsFebWaMz95d0DkRJP5FhVgNUGGINyIvcxuoePTE4ZGWuBZE0ykZIPW/JlFN6Va3dYVYBzpfNgj4OgMjllZNwpEgklBMGkaRbNhvmHB/gyCm6jnd6TI9QlFZV7D5+bMjllZNwFmL/kf0yk5LicPsEfbxAy63tTXbn9vQ072O9ap0VXLp1Pk09Zeljbq0z1oJHJKSPjTlGSkjZpDInpAmm5k8PDru1sd9LLu5z3MCn8pXs8yOSUkXEnKMnFZ31jOzHAPfMncowvHRykTzY1ym/JZWRyysi4E4TdkxxzlQrrdGr+8u7efkfE1PR1mfyrKJmfHJmcMjLuCgu6cYXV6+mTTU5Me20fa/LlTujmMcHSLauMTE4ZGXcCiKeQm5UW04Z/hICuHFMFIKXHMrnyZZHJKSPjTjC3ejm58vBwy1cW6HRYtZIZ4Yw/CcsXoDNFgUxOGRm3Cp844APdWEmHB9u2tcWqAmlgPHXjymC+1VHu1TkyOWVkvDFiFlPwSrJ++GUOU6tp/vLuwd6mTxVI35JjOgFhUigdlK6MnpHJKSPjTeGEtCSUtOMcox+WN/FVBXY3bFfE1GqKmOSfaIlQNEEPLZdRRSanjIw3xiWxeFdNjmVN+AgBC8OxpO72TtmVc2KKGLGXjjKuIpNTRsYbwqllkT7JlKYBsA7T3J/IPX3ate5mw5c6yXg1ZJFlZNwALr+wV/gnm3gad3DYsU67bkz65nwe6X41ZHLKyHhD+HSAxUxdtsI2u00R04btllMFsJjSrG+ezJURMl4KmZwyMt4IWENpgbhNdd+cmHY7trHBqgJpqgDIvPTqyOSUkfFGYA6T+eTKg4PNS4vJJ1aWq1f63CVcGSXjpZDJKSPjtbHwblt3o2VPnuz4p5t4Iod/PLVLs74B29jPeBlkcsrI+BT45Ep1zZads9IKgniYXLmnLtzTJ1u2vdmyppiKOUy+SFyNxeHkfO4ALkXPeHlkcsrI+Cw4M5XMog2Lw7VbNdvd6di+unGbmyx3UhKTAqSVK8NlRnpdZHLKyPhUQC7JUoKl+G5cu133LhzTBViHKS8QdzvI5JSR8amAmCAfZn3LYmqbr8PEkrpMG2AwvDStMm4YmZwyMkqsfn2Y41osECdiSpMrRUxPuj650tdhUrhsN90OMjllZJRIn0lPpOTEhLVUZ4G4wrY2m7Z/0LXdvQ0fCE8LxBEnbTNuHpmcMjKuhawoEQ9L6m5vM7604Vu3mHxiZSKv1OXLuA1kcsrIqGBpNYlzeALHRy7397rXEpN36PwwE9RtIJNTxpqAVn63iNlLAUjJFnPvqjGZcnurbU8Ot325k1YrfUuOWEsq8uiZmG4LmZwy3jp8bMfd3Ooih6Xj+FXcMq4U+wUOw8eNH11vrrCs4K0z7iAfvrzbaS9sb7clYlJXbqtlrUatXFmAvKaw7nzQyT0zbgFIOSPjLUOtu5x5fdnaK34v6zzep6s0IQBGEkTDe28LkdRiPpPnzOcw8ZFLxpg6HV7evYyT9qou4zaRySljTVBaI2/sXhaX85dqtbm6cQtfSWB3r+szv9n3OUyZg94aXqU2M9YcPmZyDar+MeAbftX9WwFpL13pFyi9nQF8QOdm3IuKUy2ndyUVnGkCTV9VoFyHabftqwrERy6rmV6V200h0v00dx2q514U5jpEvOtcnK+ielwNd9uo6UJ3c6WMW8Gq4sRcnSpWq3g+n1v9mnVjI+51abwO5rouLgaZG0p3sajbeLyw50cXdtwbW7FoiiTquktyDsUn7NW8Rf75Ykm1KNVyVbNM+TiulmNVBgtZS/ExS57IsaTu9nZLRMXYE8RVynLZXbxMA3/2q+m/jswiPbar6YHwp65W6wt/ygk4F/E/Kx+RZsQl/IvixnGcj30Q8a7To5vC7aWccSdYVahQvFCi6hZ/XCgUfuFfFMUyXsS5CXh6vlOS1bySvrLeoO8kQirmU3kUBi8ttMWZCMSJQiSysJnizzyMO/96LuVRPG1Z8A1iYwuJgWpZkNNludOMbyZYbm01bX+/azvqyjUUL9Zg8nBKLvIb6bBFVrH/pqimF/UT7kV1wn74vyoi7UiT/QD7q3mJa8S5iMd+HN8WsuX0ABAKE1U5m7FkbM0bfpDXZDLx8/hFI60qH1v8m82mx1klvddB1XIqZlObjMfybdh0urDjk5Gdns+s0dr087OprKhiusxP5IX8LkQQU8UnvyCIBteo63xJJr7BCqs3PU6kFeEjfiK9se3t043btI2N9I4cS51gwRFuNlPjkyP/iCJkFzIlb9W8vo68iB+NfjpN5Ys8kn6n0/H9yH9cg3gRvtVquR/nwn0aiDNWPZyentrJyYl9/vOfF0FvebzhcOj+77zzjl9jNBr5dnd31+MSjzDg4ODAz1V17KaRyekBAIWrVuMvfvELu7i4UHdl09577z0//6d/+qd2dnbmx7/yK7/i4f/+7//ew6NoNIbt7W1vBIAtDuUjfrjwjzss5zkmPUiRLcrqSit/GvdFv2+/+ODn9uN/+Ac72H8qv4bIaWgnp2OrNTbsyeG+ffTRBzadjJeNbVbM7PDw0LobXRuNR3Z8dCQS6XraKS9qGM2G/cq3vmUff/yxHR0fOwF32hv2rW/9qjeyjz78SOHNvva1r5Xy2PIGP5kMRIwf2q//+jecnFotkY6K3WyImPU3HIwkmx8pTx/bkycHym8qN/IhPsTw5S9/2fMZMkF+IQf8Qj5Vf/wiPPIBg8HA6+snP/mJl53wEZ9rPH361Osxwkc65+fnHpfw7TbjZB3fEi7CICuuhQsCoY7+7//9v/YPqgviIrN/+k//qYcJ///0n/6Ty+9nP/uZp/nv/t2/83h/8zd/Yz//+c+9Xv79v//3nl417ZtG4/8Vyv2Me45Qkl6v58oed8ZjNdy/+Iu/sB/96Eeu+L/0S7/kd8W/+qu/8kaLYvdFICg8jn2IDIeyv//++3YkcsCfLekRDgXGjzTx47r4seXa2+Ud+Ux+f//Dv7e/+PO/sJaU/fxCDfLDj+1n739gHz/72FoimR//w48U78RJiTydnZ2KaNo2GF7Ys4+fWV9+G50NNaap7t5jNcyhyjC2977wBeud9kQkH9oHIsCPPvyFfe3rX1cj+5F993t/Y8+ff2Tdbltk83dqtDNdCwvhXI3sR7a7s6FGPFVZTkVIA11PXTuVt6/8/eVf/pV973vfs43uhsp4vrQisB4++ugjb5TIBzmwpbw09ufPn7uMwp9jgB8kBKE8e/bM5UJ4jiGF7373u5421yEectzZ2XEiJCx1xPUhYsKQLkRBXggf+SP8hx9+6DKMOoWANjY2PB9cg3r/4Q9/6DeqP/uzP/Nz1Bl5+Lu/+zv71V/9VU/vBz/4gZeLY3Tn+9//vt/QIKp/8k/+yZKYQu9uGpmcHgBCQXAoTLfbdcX94IMPdOd/4kpFQwirBGWkgaCQ3JUJj9ITDn+IBgWH4Dj/J3/yJ36MwnJnRYFReBoc8WhgKDLXIz7xCPN1kQQNnq7Axx89s48U9qtfk9/GphrJRKRF4z51y20qhd/a2rbDg0PP3/b2ju3t7anhQQxjt/a+9rVv6Ny2bXa3ZVFtydJpy7J4x/b399R4W2qQ5yK9D+2b3/pl+973/1Zk8HOR3VBk01Nj/L7PYdrd6UoCMxHeB+rG0XWbyar7UPl+Litqz60ryvnjH//YG/3Xv/61Mj+6rmSBRUIZkS9yggSQA42WcH/913/tZE4ayBciQPaQAY2fOoKMsEggnyAc5El3ijJTH2z39/dd3lwTGbHlJkNYyIk8ci2IjOtR95DJH/3RHzkpEYbzkNQXROIAciIvpPFv/+2/te985zteBsKzhXi+JWv0S1/6kscj3a9+9av2u7/7u55X4qFH//gf/+NbJ6dkw2c8KKD4X/nKV5yY/uf//J+yAv7SPve5z9m//Jf/0hsAyvuHf/iHblWhhCgsiokFFEpNw4N0IBbGHP7RP/pH9m/+zb/xNDDrf+3Xfs3+9b/+126FYf7TKGi0OOJDZqSVBqnp/qlbpMZIN+Xzn/+cuixfUp7e9bGhz737Ofs13Z2//vVvKO0n3jBpBN/97ved8LBm6owtqXGcnBzb+x+8LyL9nv3BH/yBTaYTPyeK1nmskZadHJ/a0fMjm6sxt9WQhoO+fflLX1RX5LftN3/rN+zdd/dFDFv2m7/5m+4gPq4JydA4uU6n03bSQ27vvvuu55uxGUDeIJRvfOMb3sB/67d+y+Ud5EwcukL//J//c08XGVInhP9X/+pf2X/4D//B5QZpQWjf/OY37Z/9s3/m3TjqB9JCdv/n//wfJ0HikyfICcLkmDxgTWHVcH3S5bqUgRsDeSGPOEiSuNRv3MDYckx5Y8s1iUfdoROA6wLyz3msv7DMSPM2kS2nBwrubpAL4wQ0LMgE5UXpsHJoaCg2d2f8UHjukjSWGCBFASEvlBCiw6HEKPsXv/hFv8MTjzs3W+LRsFB+wjGWgbUxFYHEnV7twI6Oe1Lyj0WAp2qgHRHSUzWKXyjMkef5VBbV0dGJ0tv0vLdlfX344Ud+XRoI15pNZ25dfVMN/kN15U56x971e19dRam1tURoX/ylL8hS2tK1fqZGfyCLq6P4dDuPdd26j0Wl/E3dQYJRRkgAWfzGb/yGlwmC5jyyghgoe8gCQoIUIBf8kBeyC6JG7jRuyAR5ki77kBNp0dipE24IXJe0iEvZuTZpQjIQAzIkj6RHHWNR0bUjPGUgTeqOa2LtEY68Q56c826rLCLCc1MhDW44dNNiIByyIy9/+7d/63VLXAiUvFNu8oXllG4atzfmlAfE1xyfVj2cQzFWlQN/Gkh0N1DgUCwsHMx69lE6lBdCoNHToELZUHQaToxPRQOFGEgXBUWxUXTSJA2UFUdjIg7WFg2RBk1j+PnP33dCKebqfvQupPgjhW8rf4dKo6d4hccn71w/daW6fmene9du82Sorq4Y5WO53I6998X3vPuGRTUaDZSPoeLs2M52V6S3o/BT+/Cjn9pXv/IlHe/7+BbpNRpNH3OBJCgT+afskDXXpoyUA7mFjJEHMqLM5JF0AFvOkR6NmX2IgHogbcgEkAZWWBWERX6QDyAPpEceiMcx+zjAtUmD9MkD8oVIiMPNgTqB4KhXrkcY9unWRZ7CsqXMxKGMbMMy4hjSpUtIunTz0CHkQT2yRXdAyGYVobdx7rown4VMTmuMatXEPtuo6NgPF8Afh2KxRcHDP1CNF/4RB4VmH2WOuJF+hK0eh19cj3PEq4a5PFe38WQh60nk1BvpOI2D8UQshUvpET+lQXxPRS49gVJS8quLaNoej8Hzfv9M/oWT6LyYa8u4TVckTJdvYocHe2q4l4+96QKuliGOQeQXssQfF2FW40XYaPzhQDV8db+KahoR77L8qfsVZFjNT7iIyz7gOParID3OBarh4rqkDyJNEPkIxLVW43Ic59jG/mr8l0UmpzVGVHB1HxcVXa30auUThrsbDv9qowEcV8Ovxg1yivTZZxv7KG71XLXh4B/gHHmItLBWiDMaz2WZDKx3whOmhs9harY4l+IwY1y5LVNJYOyqKMY+faCmbhvkVK81lT4TNrk2+VM4EVRT+9vbHZGTuqjbLZ9cmbJFmsiB9JID5J0yAPIZZcRFuaNssR8gLI74cT6Af3XLedyrIvLDNuJHvgLVaxGWcOxHXYYORLkifJQxyoerno/rUY+Ac4A4pAnw4zr4ES/Si/yt6sXLIpPTGoOqwYXiY64DlAJlodsTShCKAIhDWLogdN8YVyE+XQzSoutSxWpc4kX6xON8qAlbzH+6E3QhSI/wXI+Bcq5FGBxxT0976rowf6njT8PIb3p9ZajuzFDEZJ4e40uddkvx0jWW13UykQxmE3t29AtPf3NzW1ZTR0TEhM6Z3ESkVVP3hTk/DdvZajkxpcmViZiYaZ5eRSH9dI1Im65SdEvputKlwY+uFOfxp4uFPChzNErAebqwxKGrS9gA56Le8KcuqudfFjT+IBHSC6zWW7g4pg6RLXVE3RA38kqeOE9ZqEt0AqsT0A2n/Pi7Japrkw7xqGuOOccYFfLAj+4s6UUe6QbiKC9+4V4FeUB8jYBCRQVWlS0qljkpjAmgYAyCMvYQlV8FiscjYqYAEI7xBsIx1sR8lRgED9LjGjROHATG4OxPf/pTTz+uDQiP0vI4m7EaiALFZOD0P//n/+zhaNxBUCj0t7/9+wr/l57n9977ovzV2EQSFxc8IVQeZiLS81PvchXFzOc1+aAzT+FkQTEDHAwGF/a7v/f/Kf8/9Maxs5OIjrlRP/7xPyjNmQhpW1bV1NotLAdZU2rHWFqX7Vlloe3KURaugUx4/M+cJsZ98GdKBQ2R9BkTYpyF6RGUD5KqyptyUic8FWXMifghS+IiX6YQIKdo/PhTBmSCPJF5NGwIMeJHHfHEjuuTH86TJlviki7h8MMB4qADTGPgySw6wJNC8L/+1//ytALkgbKTFkRFWCbsEpf8QLic+6//9b96niKPyId6R58YvyIdrk9eSJ9xNPKLruFfldnLIpPTmgAlD6C4HIdfVCwKg4KgRCgMA5coQITFoTg8oUM5IBCOCcOdjjkzOO6iNAiUHuUmLR4/xx2SeTgoKeE4x4AqaTNITGMmHsTFY3KUEiKLQXGuGYPKf/qnfyb/nq41UoOZ2aasIxpOTYRzesrgK4+6n/mA9nQ2tOMTpiIwyRCr6kSEw1d1k6XCLPHv/OWf2d7+rvszQN7daCvsQGm8Lz9ZTw1Zcec0CiaFPrNTNSCut729pfxfyhgiOD07ddKgEQPKzsAyDYl9GiVkg7VEmWhwWD74RTqAsMgKwmaQOKYT0HjZkj7y4Zo4BpkB1yIeYbA6kCtAtuxzDeIhf455skYd0vjjmvhRf1yTesCKIa/EJR51wOA3Wx5OoEfkE3ny9A3LhvJRr8QhLmHQF/IBmfJUFp34/d//fb8u16ds1A/XJn3SoOwxDYIw6Bey5MZImq9DTpc2YsZbBwqCArBF2VACFBe/8A8XftVzNETuYtzRaBTc5VHEP//zP/e7O+SBoqIoKA7KHYpP4yMdQDooHg2HeCgaCocSQ27c+bkeIC0aBXOFaLyEx/IgHOl+/nNfcIuJhkkjQpnHIpqhSOX4+Ll98P7P7YNf/MyePf+FffTxB77/8bMP1Th+6lMELgb95XW6m12f/X1weCAie25//8Mf2EmP2dY8WTyzs95HKsNQ+eEOPlJaSu+D91Wey/k8DKCf98+djJn/FYSEC3lj+fEonobFXDAaaHRhkR8NH9kgF/zC4Y8lQdkpK9uwwqgX9pEJ8uM8YTmGsLB0ISOmCuBHeckzcqfe0AfAPvVAOOqOdHkiS1oQBiAuRMPkSZ62Uh78Qk8gEEg2ysiNhhsQQGeYdlLtkgHyQpo81YuhAspMvoK0SQ95sSUs5QShK6+KTE5rhKhEGgrkgLKigDQYyAYF4RxKgwvFDSXgPIpKWBQVxY07Lw0AZUL5UEasIhSSuDQ4rB2shTiHEnItlI+84LgeeeTanAtAgHTnmEhII/7jP/5jb2w0DKy7fVlYrRbjPyqXumcDpUXDZixKPS01gLrOd9Qd4/G3iGWUysVrI+SP9qF7rzUbHdvZ3rVvffNb9tWvfFmE+iOV6ycm40oNpGUbcu998fM+yZNGR6Mh/8iF/FNO8h/WIQ2PMkEUyA3C4TxxkBvhyAfyp1zIi7QgWKwu5IusSYPzETeuiT/nkTtp4JA/suIceaJ8OOLgR56RG2T/27/92/brv/7rPh8LgqTRk4eoD+IRh2shz+qNh/oMqy9IBv8gWcqHIx2uzXnqPPQCR70Shy3pMaXgX/yLf+H5Yv4X8YlHesgq0mQfWXBttiC2r4I8IL4moBrCoRBUMhYQxIJCoYAoGeYzJMLdM7pPKDyOOP/7f/9vv2NiYqNUxIOoGE+hMaHEdMdIiztpTKbkWigkihZhaBj4V/NFWLY0HvJBWLoApMXdk2vR8FHQ/+d3/h/lve3nz857alzv2t9+93tqVKaGSmM0leFzdjE8V4Pd8nfwjo9PlI+Ozk1FMu+pvF+1J4dP1YCG9uff+VP71i9/Q9c9VD6nCn9kf/O3f2lf+PxThfuiyK3u19rY2PQGx92fOzlywKLjdRpkFmVkC9iHcOgq/fIv/7ITFfknHo0PGRKP+JA3sv/2t7+9bPDRsJmYiEWGpYQ/gCCQK8SCTLHUIASuyRZyIT77TIrlmtQNsicN5I4lhaVEWOqbMnEN6hQLBn/yRd6pTxBli5sbE2LRI4YG4kbFtag3ZIXOUKekhx/WNiTKWBXnueEEiXEemUA+MQMeeVFOzpEfbg7kB71cvZm9LO6UnLgUhQtwTGHAp2U+skhc9nERPtJbDRMgffyqcUHEA9X9F4F41XCR1usIPRB5ClSvgfJANty54xhlghyqZEX5OA4/lAQF4xiQJv4oFndawpPnyDfjGKRDvMhPpEnDIg8Bzkc8rhHKSNoAZeVa5Jn8Qg5YPJxnugDvv/UvhjYaF3ZyzMRPZjTTPVBZmpAAkw0pF40mTbLsdPiIZcuvc3FxpvK35TpyTRFCUw2jrzBN29yQ1aWsQWLMnSI8+SNPgAZDWatyiS1hw4KhXBAF5aC8uJAHsidNwkEyUVdsOQ9BIa9q3JA116b+iMt5rouMcOzjiB/pIfsAcZAh8QhPmdhCVKQdZSV/Ud4AxEG8sITDUiJO5J994lJ2dIG8YPGFvnGeY7acA2w5jyP9yAsgb+SHa7IlzbjWq+DOyQlERjmmIBxX/ShkNVvXZTEEUT23KgDOIdBV4F+9ZmDVfzXtqBz2Yxv5APiFfxwDjsOviqpfxAWkuZpvjlevVZXBalqB1XPXgfPVOKv4rPjXXSOlWR44OKBM6ipOmOfUL+c5iSwUVtL1gW6Qyp/2L9PRNRSGl3c3N9tqvHJbbYXFn+vj0lW4Rly7mq9qGauyBHEuXe+yPLFfjVutm+q52I9jGuWqfgeq6bG/ej6Or4sXca8rw3VpVRFxV9N/UZlWwbnV89U02a+eI4+4uM6r4M7IqXqZKAR3BBiZLccRBgaPOzNhERyVHBXN3SHSqGJVAJwnLo5r4CIN9qsVwrW4JneAuNtwnjsDdzHOAeJx9yEP4UcZiM/dMyqCu1P1Dow/YXBcg/ORX7akRxj8yTfx2JIm10HRsUiwACgD57gzcWcjT9X0OBf5IR3Kgx+I9CgX6REXEDfKShiOKT8WFdcmb2yxANgnPcpB+nEHrZYHpEuizH6kP8idcZ7CnpfkZAt1Jb2OeIrHk6KUzoK68XiX8ZsNFj7bsJ3tjiwt1emYhc/mKo8sGuWZPI1Vnl4v3eVByJ1BYPIICId/5BOEfKp+AP+qH2VGbmzxp/zsR5rUY1gv1H+c49rIDvkiR+oLRxzyRn4JT5ph4bFPfVN/1folLcpEuuQl/OM66AXxQlcA16TeCUtanCM84Hqci3xzDr3gGpwjHBZhNb1qWSlj6BjliGvhCBfuVfHWyCkUn/49JnIIjIqi/0y/mn4+YSkYFUdFUHD6sSGkOF8VAGlzPY7ZokD0zxlT4ByCx0UjB1Qq4zlchwFS4nCeCmIshUFKKoJBUwaqGW9hoJIwzAviHOM8MabBGAFjE6EE5JMwdHWoaM6RP/yjTCgCYyOEj7xxfdKkosk/RBgNA0VnjAE/zhE2ZMDAJnGQLeNA1TxwjuvFgDkI+THGQDnIEwrHwC/jCoAGw7gL6QDKQB1ynnqLBsW1kDP2EMTDMcQkLdA1mtY7pfx9u+jLGqxt2HDEoPxlY4ConJRUFJbc5XIUa3uTyZV8GQUSH/iTuIuLvvL8dTvcP1QaabD6r/7mrz3/OMpE3nh0Ttkj7/hT555P+UW+41wcUw9xDJA1T8ZCj6Ihh3zJf4z3oQPoEWFJA5mTD+REPqlr9nmQwHVoC2yJzxgVQBcJh5wDyIm655qco5yRP8qKTjCuRJuK65Mf6p0t+sCYVcThBofuE4/rE5cw5IEHGpQRPQhSjvTQL/KKP7qAPyBfjDmRZhAU14rrvSzeyjynyCRbKpOCQgpUGEtY4EfDQED4U2j2IRiESuHZJzzKQgUg4EiXBkdlki6CITzzOxishGT++3//776loSFcrhdr4HA90mJeCKRE40bw+JMnBgp5BI2i8xY610A58QdUMOEYQEQZqFzIlmv8j//xPzy/cRdkwJF0UDTS4TooPoOh5A8io9z/7b/9NycSlBKFIV/E4RooC2miQFyP9Mg/aZN3ysrSHRAp+UA2LDVCHskTSkSeudtCsqSHQnEtBpdZtoNGBfmhtJAXeadOmH5AA6RxoNTEYZ+8eL0UkEVa8+n5c+b+nKg+mvYnf/xn9nc/+JHCMP7BKylNkViheCM7Ux3wEu/zo+eqV9YOwmKTBTHqWzFTvfZ71r841/ULnWvYt3//9+1A5d7b31P8qb3/81/YT376Yx/gjZUkIXdIgHwgR3SIPOLHYDF5p0zUP3UZpIaMuBkRjvqhzJT3937v97xembxImWPFB+oLPWMKAXVMXaBj1BdpcW2uSz0Tl/lo+DNYHddnAJt8MphMHtAr8kRD5xqQD9dgkBy9R7epa/JBfVL3XJsJuMiA61N/5J1lcnjAQVlIn7pEPkxCRb/xp3zoAW0FPcBIQAcpM3mAXIlD3tBnzpF3dC+WfEFXkDHpRVjCvCrujJzIXLjqMRWPgGFfBMQTg1iwC+Gj5DxhQIFwEBIViOCo/HhqQVo0MLYoHI2QMKRPPKwdKp8Ko1GhUBBADNpRKTReKp+KJD6Cp4EiXM7haMzkAYVHQUNxIRUIgzQJH9YJisj8FtInD1Qe1yNPKBJl5O7Idbgm8XhqQz7IP4qGshA2iJIt8iEOis/1SQclZUv+aFRskSn5QY7EJQ8o9u/8zu+4sqH45I27NnKlfJEm4YlHOblDUy/IhHDkicZFXigTT+honMiTeMxmp05/KqLgyRp1ddo7VTof2s9EIMwM39jgLfq2jacjOzp+5qTCypXbW3TTmAiIhcIA91h5/L594b13rNWsa/8f1AA+VP6/qnynPB/ss5yublrPPvZrR3nRDfYpJ2VANygDBEJ9cZ66ozzIk8aE3JEZ+UeGhIOw0NPQP25epIVO0MiJQzjqhbLiD0iD61HH1CUNGDlxHmJCD3jKB+KmSzjSB6SJfKlX5E1eqT+ICB3kZsL10NnQC9Ig/+gRskF3qE/0MNod16Y9EBaiJAx5I01uVugP+8SnjSE72ia6Ee0KnaHsEB3xkSmygdjQcfQLq5rrgdi+LF69I3iDQIBUejRwjnEIg0ZFYRA6FUDlUHnsUwlUCA2YuFQmCkhYwkSapEUa+OG4BkIMcC7OE5cKgyC4u5EGjsqA0KgkBM2WBhhp47gWYQOkheKGFYLCo4woGuHx445EWmwpB9dEiVFWEHmKfc5DdhAFDgWCjACKyl01rCrCIS/kEvnm2lwHh+JQTvLHPkpI/ojHtfBni+M8DnmTDtcNRxxkQXgabciOuqChs6U8lPfJk0NfbK4ngkJWzBZvtVtuXbHM7vl5WhWTuU9Msnz33UOFm9u8GMkNVTenKgMW4Y7STDctZElaXheuOxxzYzjwhka90UDIJ3dz6gS5QFQc0ziRURAUZFaVOelT9qhrwBY9os7ZDzlRztA/9IhrsY3w5CGmIkA21BXyDL2Ja7ElrUiXdkAekT/xqE/qkHjkAT90iHrnxgYoB3EB28gX5YAYiUOdU3ekxZa04hrkjXZCXgLV9GIfQL7kj/wE6eIoC7rwJnjrr69QUJSbArLF8qCRUjgaH4VGaBScRkgYyItKwh9FIw0qhsqmAvCjQmgUKAaVzd0GZURZUUwaK6BBoUgQHtckfRSY86RFxdFoqUyujx93EfKGUlCBNBSsj2i8XJ+7CulwnnziqCzyiUJQ+ZEe+YtyssU/7mzkDdlwPRQQxSEvxOc65I194pJn4lP2uC5h8SfNIGxcWFlcG3/OA8Ija2RBuSgrykYcysfql+SDshOHcJSHspEP0qR+cMiCFScJSz55T+78/EL52dU1N2wyLSRvNWrpOucatbpP2PzmN7+m8HvK21j52VI9skaR6vzzX/C6ju4R6XOXju4biIbM4mnc1ck7ZSUOdYs+IBv20SH2SZO8U76wnJAjZaHxReMFNHyIjO4N9UM4HHrEMSQdBEf8SIv0qXscfgAZIVfySR6oaywf4oflhJWPP+cpF3mh3qlT6in8yF+QGvVCOfEnD6FH6BTyiLZE3REPWVBH3PSiXUDYyIPwpEubIT32Iz0c5QKkQXocI1PKSHzKy3G4V8FbJScECaggCoYSURgEFIWmYvGPRomwERzh2aciEQKkg6BJE+FREQgzlJE4+IcVg3IjXBogChgNP9JFAXAoO2lEnsgrx0EyVBZWAoRK2kFY+KN8KGtVMbh7UibIEH/ujIRFMVB44pIWys45roU5jRVAfihD3E3JA/6kx7WIQ3niWpwjvTiHo3yY+9wE8Md8j/yhUMgRIiEefpjqlAs/7qooNueQAw4Zkw/qgHyF9UfD5xr47+yUM5VVFhrF06fvOikdn/BeW8M+9+7nvY739nbtnaeH9vSdfXtyuC0/bgz7kkFN8jryjxAcHR0rz+mjAeSHbirjaeQROUSjDIIlrziuT74A+6EHlAFyo5tPXmlk1DPpIGPqifTQLdJBVtzoqC/Co2+UmbJzjnTRJXSDtNAl0sERFh0mLa7LlnxSds6hR9QJx+QJkGfqHP2NeqQuqFuuQf1xbcJwDdJngJ0yUn/oA3HQd0gQ/SRPlAt/wkR6IQ9A3vAnL8gR2UZ6XIs2QxzqmDySP+TAOdKI+icux8juVfFWZ4jHpatbCgLhrJ4LcOdifABlgjCi4AgPsE8c0qgKhcogLsfccVG+KvCPuKvXxJ/0I624MwIqnX42lUgjpYETjgqrliHSj/LhIj0Qea2WHUQ8sJq3SA+/iBfHq+mxBfivnsPFNaKc+EXZaAQ0opB3IOLGfpQ50mLLbnlY7tR9EuazZyyXy8uhvNOlvBQ8AUrrMD19yo2A+mEKCR8g+Ln9yZ/8kRohDdxEFtvekCABGlqQQVyXcsV+5I98k7+qHECExRG2Ws8ccz7kBSACrAiIAD0KK4jz1bRAXDtAOqvpA4658WAlsQ/BQXzsU75qOhG3mkY1HcB18CM/q+fYRpyqHy7KiUNWsV9NK9IDET7OBziuljXcq+KtktPLgiyG426EglB51YoGnF8VQsRD2MRlPyygNwVpxZ2ROw2EV23cr1MhtwXyA14mTxEWheNuSZmifOFPOqtpVQk5IWRQ1p/PWaLbPbej477IaSD/dFNhLSYmVfLlXbpxdUUjKvF4iscKA3yxBU/yEt0S6jG2gOv5tUoHohFVEediG6jqRTUNwD5lpM5x6BGyiXMhk4gTaa0eXyc//NAjUC1PoBqe9CLNahqrWA0TBFJNi22EC3BcTTeOq2HZksdq3IhT9Ytw1fReFveGnKqCfdkCv6horyOo60D6uNX0bir9t4EXyQyE7KPM1XLih6XFmAmWRSJpP+M3EiydHe++iJymPFnqi3CGSpTBZT7ZxARFxuYYw/EkRWVCOVOcXwiBwXMAUUIUdD2ikVTzjr7QbSEOVl+1IZFv4tJFoTtCXkmHLlGUibCEgZzpOrLlmPNcm64eXRe2Ac5xTa4NgZIuRBNpxvbTENeFqOImTBeNuBE/yrqaXvjh2Cc+5ScvMUwSqIZbxaelXd2vbsFqnAD+Lzr3abgX5ERlhyACL1Ng4qzGA68jqBdhVXw3mfbbwItktorV88ShYfIYn4cBjDekMAsR0zv2pS992Z/CLeZ1EQxrOR3ZyQkLnPGwgxn4jBfRfWbuW9s21ZgGFwMbDZmVXE762+o68fGeHmlDhgwc0/hozHSNIAMaMzpDWMZGIBHOYzkDwkNWTI1gTBDyYqwNcgrrmjBsGUeKJ3mkgR95gcwY66JLGYPIEBjpQS6QAnG5NsRAnrgmYQDEFQPX0RsAlItrBClGl5VwpMN55ExZ2SefEBjhyR/X5TrIgTDkJUgSeZE2+3RHcRwDwpIGYUiX65G/6vUiz1wT+SJb0ud6OMJyfa8rpR35DfequDfkFKCQZPllC3xd8V5HUC9CpH+Tab5NVOW1KufPKiuNkRUhGaT9j//xP7ofYXlRl5d4We+b4x/+8Cf2k5++bzy5a3e69uRwVwpNPathKWkaO4OtfL782bMjK2Zzb9xf+/pXbDAceAOgsdBo+G4c57CAsIQY9wsLCCsOUuGYhk48QAOj8fyX//JffICYeTqEIf+kG42bLY2VsKRD4+U8jRJC47qQGnklLCQGQdBgmdfEipLkL8aQAE8/kSN5YEAfy4uBZMZEyXMQCQ0cooecYlCaNNgyNkVZCU/emLQbZSV/+FMe8ghB4Adpch2uzTVJlwFygB9ETp4pI2WhbGGVMu5Imbg2eeGaEGpcjzAQFnnnmC03Jxz+5Af3qrgXK2FG4Vbdy+B1470sbiPNt4mqnFbLtnq8ChoyE/pwWAIx4bPfv/AnTazxBIn84Ad/p8ZXs1/5lW/YV778nv3BH37bvvjeF2SJfNUbwXe+8xdqXAf2YzXCociIpXZPT0+8Yf/8/Z8vGzcNhKdmNGQQd3saEcCC4+EJjYe4PCmlwfJEiSdjlIUnoZAEjZ3wzKaHsAjPxFLSC8Igfpyj4ZIOBAnpkSfeMiAdwnJNSIwPkZI+jZ9JkIQnn5AJhIQ/r4bEGwkA2SEHZEX+sL6Ix2RkAClwTYgQooJImElOmCBB0qA+8IvrUA7SjaeCrM8EkCMTPKkv3tCATCkbZM21IDVmsUNqXI9Z5qSPRYf1yD4y4Wk3T5xjwinnIbLP0psX4eqoW0bGa4LGCWgoWC9hUfBInPEmGjUKTiNkQuY77zy1L37xPZHFnu1s8+g/3elRZiwsGhRKT0NmKkK70/alesOK5noQQFyXO3ZYLeHHNsLTaMOawDLDH6sCSwBHvmnwxKexcp4GFcRE2jRqyJbr0rgpHw0WMuY1Hxo7aWEtkDZ5J00aNOQAuDb5gADYQn5ch/xzXbY4/DhPvkmTcEFG5A1/0iIOeYYI8CM/5Jd8QpSch2ggwwhD/kmL6zBVBAIjTRzhg/jYgpApx+SL9HHkDxcypN65BmXnGhEv3KviXlhOGfcDKCBKTaNEUdnSuFFWlBZrg8aDgnOeBhrjF2nCZvoAAIDMCAdp4GicEQdLhEYBkUE2NASsBBpWWE740fiICznSKInPMfniusTFKglCibySDvtcK6wIHGSJNUS+SA9LCoKIfEJOQXiUJfKNXAhPWuQZf1yUJxo0jR9ZsE/e2GKNRBqUKfwpI3nm+twI8CMcYSgf6WOJRXjCch3OcRw3DEiWOuE8cTiP3EiHPFMW9rke+SP/yJ+8+0MOpUn58Y/yEY40iUuanCeNV8W9GHPKWH+gRtwpUXYcx6FaNAYUlYYEaOQ0fhQX0PCjAaHYnOeYdNinwdI4UHjiEQ5lj4bMfowHBTnRIMKP65CX8OcakBnxOUd67GNBxCAv6dDQCM+YS/iTDg2YBgpxsE9aXAcigNgCEDVpRt7JZ1gzAHlEY0YGpBEEiSNclI990uM83S3KRt44z3U5Jg3yQp64HmkTnvTJP7IkDvnh2hBLkFPIizQoI+lW80y67OOHzJAFW65F+hyTLtfjWoBjzpM27lWRySnjxoAqoYRscShz+IearSpphK/iOr8X4WXCvkp64EXh8Qecq4apho0wL4NIJ9Kqpv8mqOYNxH41/ep1QezHuSqu86uiei7SW8WnxX8RMjllZGSsJfKAeEZGxloik1NGRsZaIpNTRkbGWiKTU0ZGxloik1NGRsZaIpNTRkbGWiKTU0ZGxloik1NGRsZaIpNTRkbGWiKTU0ZGxloik1NGRsZaIpNTRkbGWiKTU0ZGxloik1NGRsZaIpNTRkbGWiKTU0ZGxloik1NGRsZaIpNTRkbGWiKTU0ZGxloik1NGRsYawuz/B3jRzyr4SP+eAAAAAElFTkSuQmCC"
      style="
        height: 165px;
        width: auto;
        position: initial;
        right: 0px;
        margin-top: -120px;
        float: right;
      "
    />
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    nama: {
      type: String,
      default: "Memo Form Cuti",
    },
    tanggalSaatIni: {
      type: String,
      default: "00 xxx 0000",
    },
    tanggalMulai: {
      type: String,
      default: "00 xxx 0000",
    },
    tanggalBerakhir: {
      type: String,
      default: "00 xxx 0000",
    },
    kembaliTanggal: {
      type: String,
      default: "00 xxx 0000",
    },
    kontak: {
      type: String,
      default: "00000000000",
    },
    sisaCuti: {
      type: String,
      default: "0",
    },
    hakCuti: {
      type: String,
      default: "12",
    },
    keterangan: {
      type: String,
      default:
        "Males kerja gajian masih lama, mau beli bensin harga bensin udah naik",
    },
  },
  data: function () {
    return {
      checkedPerusahaan: [],
      headers: "",
      entitas: this.$route.query.entitas,
    };
  },
  methods: {
    getChecked() {
      if (this.entitas == "1") {
        this.checkedPerusahaan = ["vta"];
      } else if (this.entitas == "2") {
        this.checkedPerusahaan = ["sii"];
      } else if (this.entitas == "3") {
        this.checkedPerusahaan = ["ags"];
      } else if (this.entitas == "4") {
        this.checkedPerusahaan = ["tmk"];
      } else if (this.entitas == "5") {
        this.checkedPerusahaan = ["bmt"];
      } else if (this.entitas == "10") {
        this.checkedPerusahaan = ["udk"];
      } else if (this.entitas == "9") {
        this.checkedPerusahaan = ["eka"];
      } else if (this.entitas == "8") {
        this.checkedPerusahaan = ["udk"];
      } else if (this.entitas == "11") {
        this.checkedPerusahaan = ["msi"];
      }
      // console.log(this.checkedPerusahaan);
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
  },
  created() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("key"),
    };

    this.getChecked();
  },
};
</script>
